import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "./Sidebar";
import { db } from "../../firebase";
import {
  ref,
  onValue,
  push,
  set,
  remove,
  update,
  get,
} from "firebase/database";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import DownloadIcon from "@mui/icons-material/Download";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { GiWaterGallon } from "react-icons/gi";
import {
  FaRupeeSign,
  FaUser,
  FaPhone,
  FaMapMarkerAlt,
  FaIdCard,
} from "react-icons/fa";
import { TbBottleFilled } from "react-icons/tb";
import AddIcon from "@mui/icons-material/Add";
import EditNoteIcon from "@mui/icons-material/EditNote";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Groups2Icon from "@mui/icons-material/Groups2";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Tooltip,
  Legend
);

export default function AdminLayout() {
  const [selectedUser, setSelectedUser] = useState("");
  const [showAll, setShowAll] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [entries, setEntries] = useState([]);
  const [showEntryModal, setShowEntryModal] = useState(false);
  const [filterDate, setFilterDate] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [currentEntryId, setCurrentEntryId] = useState(null);
  const [entryData, setEntryData] = useState({
    date: "",
    capsuleQty: "",
    jarQty: "",
    totalPrice: 0,
  });

  const [showSales, setShowSales] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [monthlyData, setMonthlyData] = useState([]);
  const [showBookings, setShowBookings] = useState(false);
  const [bookings, setBookings] = useState([]);
  const [showInactive, setShowInactive] = useState(false);
  const [todayBookingCount, setTodayBookingCount] = useState(0);
  // const [paymentStatus, setPaymentStatus] = useState({});
  const [weeklySales, setWeeklySales] = useState([]);
  const [showEmployees, setShowEmployees] = useState(false);
  const [showEmployeeModal, setShowEmployeeModal] = useState(false);
  const [employeeData, setEmployeeData] = useState({
    empId: "",
    name: "",
    contact: "",
    address: "",
    joiningDate: new Date().toISOString().slice(0, 10),
    salaryPerDay: "",
  });
  const [employees, setEmployees] = useState([]);
  const [editEmployeeId, setEditEmployeeId] = useState(null);
  const [originalEmployeeData, setOriginalEmployeeData] = useState(null);
  const [attendanceMonth, setAttendanceMonth] = useState("");
  const [attendanceReport, setAttendanceReport] = useState([]);
  const [showAttendanceUI, setShowAttendanceUI] = useState(false);
  const [showAttendanceModal, setShowAttendanceModal] = useState(false);
  const [selectedEmpForAttendance, setSelectedEmpForAttendance] =
    useState(null);
  const [attendanceStatus, setAttendanceStatus] = useState("");
  const todayDate = new Date().toISOString().slice(0, 10);
  const [showAttendanceReportUI, setShowAttendanceReportUI] = useState(false);
  const [showCalendarModal, setShowCalendarModal] = useState(false);
  const [calendarData, setCalendarData] = useState([]);
  const [selectedCalendarEmp, setSelectedCalendarEmp] = useState(null);
  const [attendanceData, setAttendanceData] = useState({});
  const [attendanceFilter, setAttendanceFilter] = useState("all");
  const [currentUpi, setCurrentUpi] = useState("");

  const [entryMonth, setEntryMonth] = useState(
    new Date().toISOString().slice(0, 7)
  ); // 2025-02 format
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  const [globalTodaySales, setGlobalTodaySales] = useState(0);
  const [globalMonthSales, setGlobalMonthSales] = useState(0);
  const [showDaily, setShowDaily] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dailyData, setDailyData] = useState([]);
  const [paymentRequests, setPaymentRequests] = useState([]);
  const [showPaymentRequests, setShowPaymentRequests] = useState(false);
  const [paymentStatusMap, setPaymentStatusMap] = useState({});
  const [confirmAction, setConfirmAction] = useState({
    open: false,
    type: null, // "UPI" | "CASH" | "REJECT"
    row: null, // p
  });

  useEffect(() => {
  const upiRef = ref(db, "settings/upi");

  const unsubscribe = onValue(upiRef, (snapshot) => {
    if (snapshot.exists()) {
      setCurrentUpi(snapshot.val().upiId);
    } else {
      setCurrentUpi("");
    }
  });

  // cleanup
  return () => unsubscribe();
}, []);

  useEffect(() => {
    const fetchPayments = async () => {
      const snap = await get(ref(db, "paymentRequests"));
      if (!snap.exists()) return;

      const data = snap.val();
      const map = {};

      Object.keys(data).forEach((userId) => {
        Object.keys(data[userId]).forEach((month) => {
          map[`${userId}_${month}`] = data[userId][month];
        });
      });

      setPaymentStatusMap(map);
    };

    fetchPayments();
  }, []);

  useEffect(() => {
    if (!showPaymentRequests) return;

    const reqRef = ref(db, "paymentRequests");

    onValue(reqRef, (snap) => {
      if (!snap.exists()) {
        setPaymentRequests([]);
        return;
      }

      const data = snap.val();
      const list = [];

      Object.keys(data).forEach((userKey) => {
        Object.keys(data[userKey]).forEach((monthKey) => {
          const req = data[userKey][monthKey];
          if (req.status === "PENDING") {
            list.push({
              user: userKey,
              month: monthKey,
              ...req,
            });
          }
        });
      });

      setPaymentRequests(list);
    });
  }, [showPaymentRequests]);

  const fetchDailySales = async () => {
    if (!startDate) {
      alert("Please select at least START DATE");
      return;
    }

    const from = new Date(startDate);
    const to = endDate ? new Date(endDate) : new Date(startDate);

    let allData = [];

    for (const u of customers) {
      const path = u.firebaseKey;
      const entriesRef = ref(db, "entries/" + path);

      const snapshot = await get(entriesRef);
      if (!snapshot.exists()) continue;

      const userEntries = Object.values(snapshot.val());

      const filtered = userEntries.filter((e) => {
        const d = new Date(e.date);
        return d >= from && d <= to;
      });

      filtered.forEach((e) => {
        allData.push({
          date: e.date,
          userId: u.userId,
          userName: u.name,
          jarQty: e.jarQty,
          capsuleQty: e.capsuleQty,
          totalPrice: e.totalPrice,
        });
      });
    }

    setDailyData(allData);
  };

  const generateEmployeeId = () => {
    return "EMP" + Math.floor(1000 + Math.random() * 9000);
  };

  const openEmployeeModal = () => {
    setEditEmployeeId(null);
    setOriginalEmployeeData(null);
    setEmployeeData({
      empId: generateEmployeeId(),
      name: "",
      contact: "",
      address: "",
      joiningDate: new Date().toISOString().slice(0, 10),
      salaryPerDay: "",
    });
    setShowEmployeeModal(true);
  };

  const handleEditEmployee = (emp) => {
    const data = {
      empId: emp.empId,
      name: emp.name,
      contact: emp.contact,
      address: emp.address,
      joiningDate: emp.joiningDate,
      salaryPerDay: emp.salaryPerDay,
    };

    setEmployeeData(data);
    setOriginalEmployeeData(data);
    setEditEmployeeId(emp.firebaseKey);
    setShowEmployeeModal(true);
  };

  const updateEmployee = async () => {
    if (!editEmployeeId) return;

    try {
      await update(ref(db, "employees/" + editEmployeeId), {
        ...employeeData,
        updatedAt: new Date().toISOString(),
      });

      alert("Employee updated successfully!");
      setShowEmployeeModal(false);
      setEditEmployeeId(null);
    } catch (error) {
      console.error(error);
      alert("Error updating employee");
    }
  };

  const handleDeleteEmployee = async (firebaseKey) => {
    const ok = window.confirm("Are you sure you want to delete this employee?");
    if (!ok) return;

    try {
      await remove(ref(db, "employees/" + firebaseKey));
      alert("Employee deleted successfully!");
    } catch (error) {
      console.error(error);
      alert("Error deleting employee");
    }
  };

  const closeEmployeeModal = () => {
    setShowEmployeeModal(false);
    setEditEmployeeId(null);
    setOriginalEmployeeData(null);
    setEmployeeData({
      empId: generateEmployeeId(),
      name: "",
      contact: "",
      address: "",
      joiningDate: new Date().toISOString().slice(0, 10),
      salaryPerDay: "",
    });
  };

  // FETCH ATTENDANCE DATA
  useEffect(() => {
    const attRef = ref(db, "attendance/");
    onValue(attRef, (snap) => {
      if (snap.exists()) {
        setAttendanceData(snap.val());
      } else {
        setAttendanceData({});
      }
    });
  }, []);

  useEffect(() => {
    const empRef = ref(db, "employees/");
    onValue(empRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const list = Object.keys(data).map((key) => ({
          firebaseKey: key,
          ...data[key],
        }));
        setEmployees(list);
      } else {
        setEmployees([]);
      }
    });
  }, []);

  useEffect(() => {
    if (!attendanceMonth) return;

    const attRef = ref(db, "attendance/");
    onValue(attRef, (snap) => {
      if (!snap.exists()) {
        setAttendanceReport([]);
        return;
      }

      const data = snap.val();
      const report = [];

      employees.forEach((emp) => {
        let present = 0;
        let absent = 0;
        let leave = 0;
        let halfday = 0;

        Object.keys(data).forEach((dateKey) => {
          if (dateKey.startsWith(attendanceMonth)) {
            const rec = data[dateKey][emp.empId];
            if (rec) {
              if (rec.status === "present") present++;
              else if (rec.status === "absent") absent++;
              else if (rec.status === "leave") leave++;
              else if (rec.status === "halfday") halfday++;
            }
          }
        });

        report.push({
          empId: emp.empId,
          name: emp.name,
          salary: emp.salaryPerDay,
          present,
          absent,
          leave,
          halfday,
        });
      });

      setAttendanceReport(report);
    });
  }, [attendanceMonth, employees]);

  const handleSubmitAttendance = async () => {
    if (!attendanceStatus) {
      alert("Please select attendance status");
      return;
    }

    const emp = selectedEmpForAttendance;
    const today = new Date().toISOString().slice(0, 10);

    try {
      await set(ref(db, `attendance/${today}/${emp.empId}`), {
        empId: emp.empId,
        name: emp.name,
        status: attendanceStatus,
        salary: emp.salaryPerDay,
        date: today,
        timestamp: new Date().toISOString(),
      });

      alert(`${emp.name} attendance saved as '${attendanceStatus}'`);
      setShowAttendanceModal(false);
    } catch (err) {
      console.error(err);
      alert("Error saving attendance");
    }
  };

  const openCalendarModal = (emp) => {
    // SELECT EMPLOYEE
    setSelectedCalendarEmp(emp);

    // ---- FIX #1: Ensure attendanceMonth is always valid ----
    let month = attendanceMonth;
    if (!month || month.trim() === "") {
      month = new Date().toISOString().slice(0, 7);
      setAttendanceMonth(month);
    }

    // ---- FIX #2: Extract Days of that Month ----
    const [yr, mn] = month.split("-");
    const days = new Date(yr, mn, 0).getDate();

    let temp = [];

    for (let d = 1; d <= days; d++) {
      const dateKey = `${month}-${String(d).padStart(2, "0")}`;

      const status = attendanceData[dateKey]?.[emp.empId]?.status || "none";

      temp.push({
        date: dateKey,
        status,
      });
    }

    setCalendarData(temp);

    // OPEN MODAL
    setShowCalendarModal(true);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps

  const generateMonthlyAttendanceReport = useCallback(
    (month) => {
      let report = [];

      employees.forEach((emp) => {
        let present = 0;
        let absent = 0;
        let leave = 0;
        let halfday = 0;

        Object.keys(attendanceData).forEach((dateKey) => {
          if (dateKey.startsWith(month)) {
            const rec = attendanceData[dateKey]?.[emp.empId];
            if (rec) {
              if (rec.status === "present") present++;
              else if (rec.status === "absent") absent++;
              else if (rec.status === "leave") leave++;
              else if (rec.status === "halfday") halfday++;
            }
          }
        });

        report.push({
          empId: emp.empId,
          name: emp.name,
          salary: emp.salaryPerDay,
          present,
          absent,
          leave,
          halfday,
        });
      });

      setAttendanceReport(report);
    },
    [employees, attendanceData]
  );

  useEffect(() => {
    if (!attendanceMonth) return;
    generateMonthlyAttendanceReport(attendanceMonth);
  }, [attendanceMonth, generateMonthlyAttendanceReport]);

  const downloadMonthlyAttendanceExcel = () => {
    if (!attendanceReport || attendanceReport.length === 0) {
      alert("No attendance data available for this month.");
      return;
    }

    const formattedData = attendanceReport.map((emp) => ({
      "Emp ID": emp.empId,
      Name: emp.name,
      Present: emp.present,
      Absent: emp.absent,
      "Half Day": emp.halfday,
      Leave: emp.leave,
      "Salary Per Day": emp.salary,
      "Total Salary (₹)":
        emp.present * emp.salary + emp.halfday * (emp.salary / 2),
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Monthly Report");

    const fileName = `Attendance_Report_${attendanceMonth}.xlsx`;

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(file, fileName);
  };

  useEffect(() => {
    const entriesRef = ref(db, "entries/");
    onValue(entriesRef, (snapshot) => {
      const data = snapshot.val();
      if (!data) return;

      let todayTotal = 0;
      let monthTotal = 0;

      const today = new Date().toISOString().slice(0, 10);
      const currentMonth = new Date().toLocaleString("default", {
        month: "short",
        year: "numeric",
      });

      Object.values(data).forEach((userEntries) => {
        Object.values(userEntries).forEach((entry) => {
          const entryDate = entry.date;

          // Today Sales
          if (entryDate === today) {
            todayTotal += Number(entry.totalPrice);
          }

          // Current Month Sales
          const entryMonth = new Date(entryDate).toLocaleString("default", {
            month: "short",
            year: "numeric",
          });

          if (entryMonth === currentMonth) {
            monthTotal += Number(entry.totalPrice);
          }
        });
      });

      setGlobalTodaySales(todayTotal);
      setGlobalMonthSales(monthTotal);
    });
  }, []);

  // useEffect(() => {
  //   const payRef = ref(db, "paymentStatus/");
  //   onValue(payRef, (snap) => {
  //     setPaymentStatus(snap.val() || {});
  //   });
  // }, []);

  // const updatePaymentStatus = (userKey, monthLabel, mode) => {
  //   const payRef = ref(db, `paymentStatus/${userKey}/${monthLabel}`);
  //   set(payRef, mode);
  // };

  useEffect(() => {
    const entriesRef = ref(db, "entries/");

    onValue(entriesRef, (snapshot) => {
      const data = snapshot.val();
      if (!data) return;

      const now = new Date();

      // Last 6 months sales
      const monthSales = {};
      for (let i = 5; i >= 0; i--) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
        const label = d.toLocaleString("default", {
          month: "short",
          year: "numeric",
        });
        monthSales[label] = 0;
      }

      // last 7 days sales
      const weekSales = {};
      for (let i = 6; i >= 0; i--) {
        const d = new Date(now);
        d.setDate(now.getDate() - i);
        const label = d.toISOString().slice(0, 10);
        weekSales[label] = 0;
      }

      Object.values(data).forEach((userEntries) => {
        Object.values(userEntries).forEach((entry) => {
          const entryDate = entry.date;
          const entryMonth = new Date(entryDate).toLocaleString("default", {
            month: "short",
            year: "numeric",
          });

          if (monthSales[entryMonth] !== undefined) {
            monthSales[entryMonth] += Number(entry.totalPrice);
          }

          if (weekSales[entryDate] !== undefined) {
            weekSales[entryDate] += Number(entry.totalPrice);
          }
        });
      });

      // setLast6Months(Object.entries(monthSales));
      setWeeklySales(Object.entries(weekSales));
    });
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (selectedUser) {
      const currentMonth = new Date().toISOString().slice(0, 7);
      setEntryMonth(currentMonth);
    }
  }, [selectedUser]);

  useEffect(() => {
    const handleShowSales = () => {
      setShowSales(true);
      setShowBookings(false);
      setShowAll(false);
      setSelectedUser("");
    };
    window.addEventListener("showSalesTable", handleShowSales);
    return () => window.removeEventListener("showSalesTable", handleShowSales);
  }, []);

  //

  useEffect(() => {
    if (!selectedMonth) return;

    const entriesRef = ref(db, "entries/");

    onValue(entriesRef, (snapshot) => {
      const data = snapshot.val();
      if (!data) {
        setMonthlyData([]);
        return;
      }

      const summary = {};

      Object.keys(data).forEach((userKey) => {
        const userEntries = data[userKey];

        Object.keys(userEntries).forEach((entryKey) => {
          const entry = userEntries[entryKey];

          const entryMonth = new Date(entry.date).toLocaleString("default", {
            month: "short",
            year: "numeric",
          });

          if (entryMonth === selectedMonth) {
            if (!summary[userKey]) {
              summary[userKey] = {
                name: entry.userName || "",
                jarQty: 0,
                capsuleQty: 0,
                totalPrice: 0,
              };
            }

            summary[userKey].jarQty += Number(entry.jarQty || 0);
            summary[userKey].capsuleQty += Number(entry.capsuleQty || 0);
            summary[userKey].totalPrice += Number(entry.totalPrice || 0);
          }
        });
      });

      // 🔥 RAW DATA
      const rawResult = Object.keys(summary).map((key) => {
        const user = customers.find((c) => c.firebaseKey === key);

        return {
          firebaseKey: key,
          userId: user?.userId || "N/A",
          name: user?.name || "",
          jarQty: summary[key].jarQty,
          capsuleQty: summary[key].capsuleQty,
          totalPrice: summary[key].totalPrice,
        };
      });

      // 🔥 ENRICH WITH PAYMENT STATUS
      const enrichedData = rawResult.map((item) => {
        const mapKey = `${item.userId}_${selectedMonth}`;

        return {
          ...item,
          status: paymentStatusMap[mapKey]?.status || "UNPAID",
          paymentMode: paymentStatusMap[mapKey]?.paymentMode || null,
        };
      });

      setMonthlyData(enrichedData);
    });
  }, [selectedMonth, customers, paymentStatusMap]);

  // Fetch customers
  useEffect(() => {
    const usersRef = ref(db, "users/");
    return onValue(usersRef, (snapshot) => {
      const data = snapshot.val();
      setCustomers(
        data
          ? Object.keys(data).map((key) => ({
              firebaseKey: key,
              ...data[key],
            }))
          : []
      );
    });
  }, []);

  const selectedUserDetails = customers.find((u) => u.name === selectedUser);

  // Auto calculate total
  useEffect(() => {
    if (selectedUserDetails) {
      const capsuleRate = parseFloat(selectedUserDetails.capsulePrice || 0);
      const jarRate = parseFloat(selectedUserDetails.jarPrice || 0);
      const total =
        (Number(entryData.capsuleQty) || 0) * capsuleRate +
        (Number(entryData.jarQty) || 0) * jarRate;
      setEntryData((prev) => ({ ...prev, totalPrice: total }));
    }
  }, [entryData.capsuleQty, entryData.jarQty, selectedUserDetails]);

  // Function to close modal and reset entry data/state
  const closeEntryModal = () => {
    setShowEntryModal(false);
    setIsEditing(false);
    setCurrentEntryId(null);
    setEntryData({ date: "", capsuleQty: "", jarQty: "", totalPrice: 0 });
  };

  // Save New Entry
  const handleSaveEntry = async () => {
    const exists = entries.some((e) => e.date === entryData.date);

    if (exists && !isEditing) {
      alert("⚠ This date already has an entry!");
      return;
    }

    if (
      !entryData.date ||
      (Number(entryData.capsuleQty) === 0 && Number(entryData.jarQty) === 0)
    ) {
      alert("Please enter a date and at least one quantity (Capsule or Jar)!");
      return;
    }

    try {
      const entryRef = push(
        ref(db, `entries/${selectedUserDetails.firebaseKey}`)
      );
      await set(entryRef, {
        ...entryData,
        userName: selectedUserDetails.name,
        createdAt: new Date().toISOString(),
      });

      alert("✅ Entry added successfully!");
      closeEntryModal();
    } catch (err) {
      console.error(err);
      alert("❌ Error adding entry");
    }
  };

  // Handle Edit Button Click
  const handleEdit = (entry) => {
    setIsEditing(true);
    setCurrentEntryId(entry.id);
    setEntryData({
      date: entry.date,
      capsuleQty: entry.capsuleQty,
      jarQty: entry.jarQty,
      totalPrice: entry.totalPrice,
    });
    setShowEntryModal(true);
  };

  const markPaid = async (p, mode) => {
    if (p.status !== "PENDING") return;

    try {
      const userKey = p.userId;
      const monthKey = p.month;

      await update(ref(db, `paymentRequests/${userKey}/${monthKey}`), {
        status: "SUCCESS",
        paymentMode: mode, // "UPI" | "CASH"
        approvedAt: new Date().toISOString(),
      });

      // alert(`✅ Payment approved via ${mode}`);
    } catch (err) {
      console.error(err);
      // alert("❌ Failed to approve payment");
    }
  };

  const rejectPayment = async (p) => {
    if (p.status !== "PENDING") return;

    try {
      const userKey = p.userId;
      const monthKey = p.month;

      await update(ref(db, `paymentRequests/${userKey}/${monthKey}`), {
        status: "REJECTED",
        paymentMode: null,
        rejectedAt: new Date().toISOString(),
      });

      // alert("❌ Payment rejected");
    } catch (err) {
      console.error(err);
      // alert("❌ Failed to reject payment");
    }
  };

  const today = new Date().toISOString().slice(0, 10);
  const isTablet = window.innerWidth >= 600 && window.innerWidth <= 1024;

  const confirmYes = async () => {
    const { type, row } = confirmAction;
    if (!row) return;

    if (type === "REJECT") {
      await rejectPayment(row);
    } else {
      await markPaid(row, type); // UPI / CASH
    }

    setConfirmAction({ open: false, type: null, row: null });
  };

  useEffect(() => {
    const handleShowBookings = () => {
      setShowBookings(true);
      setShowAll(false);
      setShowSales(false);
      setSelectedUser("");
    };

    window.addEventListener("showBookingsTable", handleShowBookings);
    return () =>
      window.removeEventListener("showBookingsTable", handleShowBookings);
  }, []);

  useEffect(() => {
    const bookingsRef = ref(db, "bookings/");
    onValue(bookingsRef, (snapshot) => {
      const data = snapshot.val();
      if (!data) {
        setBookings([]);
        setTodayBookingCount(0);
        return;
      }

      // Convert to array
      const allBookings = Object.entries(data).map(
        ([userName, bookingData]) => ({
          userName,
          service: bookingData.service || "-",
          date: bookingData.date || "-",
          time: bookingData.time || "-",
          jars: bookingData.jars || "-",
          capsules: bookingData.capsules || "-",
          address: bookingData.address || "-",
          contact: bookingData.contact || "-",
          createdAt: bookingData.createdAt || "",
        })
      );

      // Sort by latest
      allBookings.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setBookings(allBookings);

      // Count today's bookings
      const today = new Date().toISOString().slice(0, 10); // yyyy-mm-dd
      const count = allBookings.filter((b) => b.date === today).length;

      setTodayBookingCount(count);
    });
  }, []);

  const saveEmployee = async () => {
    if (
      !employeeData.name ||
      !employeeData.contact ||
      !employeeData.salaryPerDay ||
      !employeeData.joiningDate ||
      !employeeData.address
    ) {
      alert("Please fill required fields");
      return;
    }

    try {
      const empRef = push(ref(db, "employees/"));
      await set(empRef, {
        ...employeeData,
        createdAt: new Date().toISOString(),
      });

      alert("Employee added successfully!");
      setShowEmployeeModal(false);
    } catch (error) {
      console.error(error);
      alert("Error saving employee");
    }
  };

  // Update Entry
  const handleUpdateEntry = async () => {
    if (
      !entryData.date ||
      (Number(entryData.capsuleQty) === 0 && Number(entryData.jarQty) === 0)
    ) {
      alert("Please ensure all fields are correctly filled!");
      return;
    }

    if (!currentEntryId || !selectedUserDetails) return;

    try {
      const entryRef = ref(
        db,
        `entries/${selectedUserDetails.firebaseKey}/${currentEntryId}`
      );
      await set(entryRef, {
        ...entryData,
        userName: selectedUserDetails.name,
        updatedAt: new Date().toISOString(),
      });

      alert("✅ Entry updated successfully!");
      closeEntryModal();
    } catch (err) {
      console.error(err);
      alert("❌ Error updating entry");
    }
  };

  // Delete Entry
  const handleDeleteEntry = async (entryId) => {
    if (!window.confirm("Are you sure you want to delete this entry?")) return;
    if (!entryId || !selectedUserDetails) return;

    try {
      const entryRef = ref(
        db,
        `entries/${selectedUserDetails.firebaseKey}/${entryId}`
      );
      await remove(entryRef);
      alert("✅ Entry deleted successfully!");
    } catch (err) {
      console.error(err);
      alert("❌ Error deleting entry");
    }
  };

  // Add here
  const handleSelectCustomer = (customer) => {
    setSelectedUser(customer.name);
    setShowAll(false);
    setShowSales(false);
  };

  // Fetch entries
  useEffect(() => {
    if (!selectedUserDetails) {
      setEntries([]);
      return;
    }

    const entriesRef = ref(db, `entries/${selectedUserDetails.firebaseKey}`);
    const unsubscribe = onValue(entriesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const entryList = Object.keys(data).map((key) => ({
          id: key,
          ...data[key],
        }));
        entryList.sort((a, b) => new Date(b.date) - new Date(a.date));
        setEntries(entryList);
      } else {
        setEntries([]);
      }
    });

    return () => unsubscribe();
  }, [selectedUserDetails]);

  // Filter entries
  // MONTH LOGIC + DATE FILTER BOTH
  const filteredEntries = entries.filter((e) => {
    const entryMonthValue = e.date.slice(0, 7);

    // AUTO: Reset table when month changes
    if (entryMonthValue !== entryMonth) return false;

    // Manual date filter (optional)
    if (filterDate && e.date !== filterDate) return false;

    return true;
  });

  // Totals
  const totalCapsules = filteredEntries.reduce(
    (sum, e) => sum + Number(e.capsuleQty || 0),
    0
  );
  const totalJars = filteredEntries.reduce(
    (sum, e) => sum + Number(e.jarQty || 0),
    0
  );
  const totalPrice = filteredEntries.reduce(
    (sum, e) => sum + Number(e.totalPrice || 0),
    0
  );

  // Download Excel
  const handleDownloadExcel = () => {
    if (filteredEntries.length === 0) {
      alert("No data to download!");
      return;
    }

    // Clean up data for Excel
    const dataForExcel = filteredEntries.map(
      ({ id, userName, createdAt, updatedAt, ...rest }) => rest
    );

    const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Entries");

    const fileName = `entries_${selectedUserDetails?.name || "user"}_${
      filterDate || "all"
    }.xlsx`;

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, fileName);
  };

  // Calculate today's totals
  let totalPresent = 0;
  let totalAbsent = 0;
  let totalLeave = 0;
  let totalHalfday = 0;

  employees.forEach((emp) => {
    const status = attendanceData[today]?.[emp.empId]?.status || "none";

    if (status === "present") totalPresent++;
    else if (status === "absent") totalAbsent++;
    else if (status === "leave") totalLeave++;
    else if (status === "halfday") totalHalfday++;
  });

  return (
    <div style={{ display: "flex", height: "auto", background: "#f7f9f9" }}>
      <Sidebar
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        setShowAll={setShowAll}
        setShowSales={setShowSales}
        setShowBookings={setShowBookings}
        setShowInactive={setShowInactive}
        todayBookingCount={todayBookingCount}
        setShowDaily={setShowDaily}
        setShowEmployees={setShowEmployees}
        setShowAttendanceUI={setShowAttendanceUI}
        setShowAttendanceReportUI={setShowAttendanceReportUI}
        setShowPaymentRequests={setShowPaymentRequests}
      />

      <div
        style={{
          flexGrow: 1,
          padding: 20,
          overflowY: "auto",
          scrollbarWidth: "none",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            flexDirection: window.innerWidth <= 600 ? "column" : "row",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#fff",
            padding: window.innerWidth <= 600 ? "12px 16px" : "15px 20px",
            borderRadius: 12,
            boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
            marginBottom: 20,
            gap: window.innerWidth <= 600 ? "12px" : "0",
            textAlign: window.innerWidth <= 600 ? "center" : "left",
          }}
        >
          <h2
            style={{
              color: "#022c32",
              margin: 0,
              display: "flex",
              alignItems: "center",
              gap: 6,
              fontSize: window.innerWidth <= 600 ? "18px" : "inherit",
              justifyContent:
                window.innerWidth <= 600 ? "center" : "flex-start",
              width: window.innerWidth <= 600 ? "100%" : "auto",
            }}
          >
            {selectedUser ? (
              `👤 ${selectedUser}`
            ) : showAll ? (
              <>
                <PeopleAltIcon
                  style={{
                    color: "#022c32",
                    fontSize: window.innerWidth <= 600 ? "18px" : "24px",
                    marginRight: "2px",
                  }}
                />
                <p
                  style={{
                    fontSize: window.innerWidth <= 600 ? "18px" : "",
                    color: "#022c32",
                    textAlign: "center",
                    margin: 0,
                  }}
                >
                  All Customers
                </p>
              </>
            ) : showSales ? (
              <>
                <CurrencyRupeeIcon
                  style={{
                    color: "#022c32",
                    fontSize: window.innerWidth <= 600 ? "18px" : "24px",
                    marginRight: "2px",
                  }}
                />
                <p
                  style={{
                    fontSize: window.innerWidth <= 600 ? "18px" : "",
                    color: "#022c32",
                    margin: 0,
                  }}
                >
                  Monthly Sales Review
                </p>
              </>
            ) : (
              "👋 Welcome, Admin!"
            )}
          </h2>

          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: window.innerWidth <= 600 ? "center" : "flex-end",
              width: window.innerWidth <= 600 ? "100%" : "auto",
            }}
          >
            {/* View All Customers Button */}
            {!selectedUser && (
              <button
                onClick={() => {
                  setShowAll(!showAll);
                  setShowSales(false);
                }}
                style={{
                  background: showAll
                    ? "linear-gradient(120deg, #e53935, #ff5252)"
                    : "linear-gradient(120deg, #03b8b3, #04d4cd)",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: window.innerWidth <= 600 ? "8px 14px" : "10px 18px",
                  fontWeight: 600,
                  cursor: "pointer",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
                  fontSize: window.innerWidth <= 600 ? "13px" : "14px",
                  whiteSpace: "nowrap",
                  minWidth: window.innerWidth <= 600 ? "120px" : "auto",
                }}
              >
                {showAll ? "Hide All" : "View All Customers"}
              </button>
            )}

            {selectedUser && !showAll && (
              <button
                onClick={() => {
                  setIsEditing(false);
                  setCurrentEntryId(null);
                  setEntryData({
                    date: new Date().toISOString().substring(0, 10),
                    capsuleQty: "",
                    jarQty: "",
                    totalPrice: 0,
                  }); // Pre-fill today's date
                  setShowEntryModal(true);
                }}
                style={{
                  background: "linear-gradient(120deg, #03b8b3, #04d4cd)",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: window.innerWidth <= 600 ? "8px 14px" : "10px 18px",
                  fontWeight: 600,
                  cursor: "pointer",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
                  display: "flex",
                  alignItems: "center",
                  gap: 3,
                  fontSize: window.innerWidth <= 600 ? "13px" : "14px",
                  minWidth: window.innerWidth <= 600 ? "80px" : "auto",
                }}
              >
                <AddIcon
                  style={{
                    fontSize: window.innerWidth <= 600 ? "20px" : "26px",
                    filter: "drop-shadow(1px 1px 1px rgba(0,0,0,0.5))",
                    transform: "scale(1.1)",
                  }}
                />
                Add
              </button>
            )}
          </div>
        </div>

        {!selectedUser &&
          !showAll &&
          !showSales &&
          !showBookings &&
          !showInactive &&
          !showDaily &&
          !showEmployees &&
          !showAttendanceUI &&
          !showAttendanceReportUI &&
          !showPaymentRequests && (
            <>
              {/* TOP METRIC CARDS */}
              {/* 🔥 TOP METRIC CARDS – Cute Glass UI */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    window.innerWidth <= 600
                      ? "repeat(2, minmax(0, 1fr))" // mobile → 2 cards per row
                      : window.innerWidth <= 1024
                      ? "repeat(2, minmax(0, 1fr))" // tablet → 2 cards per row
                      : "repeat(3, minmax(0, 1fr))", // desktop → 3 cards per row
                  gap: isMobile ? 10 : 18,
                  marginBottom: 22,
                }}
              >
                {/* ACTIVE CUSTOMERS */}
                <div
                  style={{
                    padding: isMobile ? 12 : 18,
                    borderRadius: 18,
                    background:
                      "linear-gradient(145deg, rgba(3,184,179,0.12), rgba(4,212,205,0.22))",
                    border: "1px solid rgba(3,184,179,0.15)",
                    backdropFilter: "blur(10px)",
                    boxShadow: "0 10px 25px rgba(3,184,179,0.18)",
                    color: "#022c32",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        width: 34,
                        height: 34,
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, #03b8b3, #04d4cd)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 4px 12px rgba(3,184,179,0.4)",
                        color: "#fff",
                        fontSize: 18,
                      }}
                    >
                      👥
                    </div>
                    <span
                      style={{
                        fontSize: 11,
                        fontWeight: 600,
                        color: "#059488",
                        background: "rgba(5,148,136,0.08)",
                        padding: "3px 8px",
                        borderRadius: 999,
                      }}
                    >
                      Active
                    </span>
                  </div>

                  <p
                    style={{
                      marginTop: 10,
                      marginBottom: 0,
                      fontSize: isMobile ? 11 : 13,
                      opacity: 0.75,
                    }}
                  >
                    Active Customers
                  </p>
                  <h2
                    style={{
                      margin: "4px 0 0",
                      fontSize: isMobile ? 22 : 30,
                      fontWeight: 700,
                    }}
                  >
                    {customers.filter((c) => c.status !== "inactive").length}
                  </h2>
                </div>

                {/* SALES THIS MONTH */}
                <div
                  style={{
                    padding: isMobile ? 12 : 18,
                    borderRadius: 18,
                    background:
                      "linear-gradient(145deg, rgba(4,137,212,0.12), rgba(3,184,179,0.22))",
                    border: "1px solid rgba(4,137,212,0.15)",
                    backdropFilter: "blur(10px)",
                    boxShadow: "0 10px 25px rgba(4,137,212,0.18)",
                    color: "#022c32",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        width: 34,
                        height: 34,
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, #0489d4, #03b8b3)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 4px 12px rgba(4,137,212,0.4)",
                        color: "#fff",
                        fontSize: 18,
                      }}
                    >
                      ₹
                    </div>
                    <span
                      style={{
                        fontSize: 11,
                        fontWeight: 600,
                        color: "#127c2f",
                        background: "rgba(35,155,86,0.08)",
                        padding: "3px 8px",
                        borderRadius: 999,
                      }}
                    >
                      This month
                    </span>
                  </div>

                  <p
                    style={{
                      marginTop: 10,
                      marginBottom: 0,
                      fontSize: isMobile ? 11 : 13,
                      opacity: 0.75,
                    }}
                  >
                    Sales This Month
                  </p>
                  <h2
                    style={{
                      margin: "4px 0 0",
                      fontSize: isMobile ? 22 : 30,
                      fontWeight: 700,
                    }}
                  >
                    ₹{globalMonthSales.toFixed(2)}
                  </h2>
                </div>

                {/* TODAY SALES */}
                <div
                  style={{
                    padding: isMobile ? 12 : 18,
                    borderRadius: 18,
                    background:
                      "linear-gradient(145deg, rgba(255,140,66,0.14), rgba(255,106,0,0.22))",
                    border: "1px solid rgba(255,140,66,0.16)",
                    backdropFilter: "blur(10px)",
                    boxShadow: "0 10px 25px rgba(255,140,66,0.22)",
                    color: "#4a2600",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        width: 34,
                        height: 34,
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, #ff8c42, #ff6a00)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 4px 12px rgba(255,140,66,0.4)",
                        color: "#fff",
                        fontSize: 18,
                      }}
                    >
                      ⚡
                    </div>
                    <span
                      style={{
                        fontSize: 11,
                        fontWeight: 600,
                        color: "#c0392b",
                        background: "rgba(192,57,43,0.08)",
                        padding: "3px 8px",
                        borderRadius: 999,
                      }}
                    >
                      Today
                    </span>
                  </div>

                  <p
                    style={{
                      marginTop: 10,
                      marginBottom: 0,
                      fontSize: isMobile ? 11 : 13,
                      opacity: 0.75,
                    }}
                  >
                    Today&apos;s Sales
                  </p>
                  <h2
                    style={{
                      margin: "4px 0 0",
                      fontSize: isMobile ? 22 : 30,
                      fontWeight: 700,
                    }}
                  >
                    ₹{globalTodaySales.toFixed(2)}
                  </h2>
                </div>

                {/* TOTAL EMPLOYEES */}
                <div
                  style={{
                    padding: isMobile ? 12 : 18,
                    borderRadius: 18,
                    background:
                      "linear-gradient(135deg, rgba(255, 165, 89, 0.18), rgba(255, 200, 150, 0.22))",
                    border: "1px solid rgba(255,165,89,0.18)",
                    boxShadow: "0 10px 25px rgba(255,165,89,0.25)",
                    color: "#4a2b0b",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        width: 34,
                        height: 34,
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, #1e3c72, #2a5298)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 4px 12px rgba(30,60,114,0.45)",
                        color: "#fff",
                        fontSize: 18,
                      }}
                    >
                      👨‍💼
                    </div>
                    <span
                      style={{
                        fontSize: 11,
                        fontWeight: 600,
                        color: "#485baeff",
                        background: "rgba(202, 51, 51, 0.08)",
                        padding: "3px 8px",
                        borderRadius: 999,
                      }}
                    >
                      Employees
                    </span>
                  </div>

                  <p
                    style={{
                      marginTop: 10,
                      marginBottom: 0,
                      fontSize: isMobile ? 11 : 13,
                      opacity: 0.85,
                    }}
                  >
                    Total Employees
                  </p>
                  <h2
                    style={{
                      margin: "4px 0 0",
                      fontSize: isMobile ? 22 : 30,
                      fontWeight: 700,
                    }}
                  >
                    {employees.length}
                  </h2>
                </div>

                {/* ATTENDANCE SUMMARY */}
                <div
                  style={{
                    padding: isMobile ? 12 : 18,
                    borderRadius: 18,
                    background:
                      "linear-gradient(145deg, rgba(46,204,113,0.12), rgba(88,214,141,0.2))",
                    border: "1px solid rgba(46,204,113,0.18)",
                    backdropFilter: "blur(10px)",
                    boxShadow: "0 10px 25px rgba(46,204,113,0.2)",
                    color: "#0d3b24",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontSize: isMobile ? 11 : 13,
                      opacity: 0.85,
                      fontWeight: 600,
                    }}
                  >
                    Attendance Today
                  </p>

                  <div
                    style={{
                      display: "flex",
                      marginTop: 10,
                      gap: 8,
                      flexWrap: "wrap",
                      fontSize: isMobile ? 11 : 12,
                      fontWeight: 600,
                    }}
                  >
                    <span
                      style={{
                        background: "#c8f7c5",
                        padding: "4px 8px",
                        borderRadius: 999,
                        whiteSpace: "nowrap",
                      }}
                    >
                      ✅ Present: {totalPresent}
                    </span>
                    <span
                      style={{
                        background: "#f7c5c5",
                        padding: "4px 8px",
                        borderRadius: 999,
                        whiteSpace: "nowrap",
                      }}
                    >
                      ❌ Absent: {totalAbsent}
                    </span>
                    <span
                      style={{
                        background: "#f7eac5",
                        padding: "4px 8px",
                        borderRadius: 999,
                        whiteSpace: "nowrap",
                      }}
                    >
                      💤 Leave: {totalLeave}
                    </span>
                    <span
                      style={{
                        background: "#c5e0f7",
                        padding: "4px 8px",
                        borderRadius: 999,
                        whiteSpace: "nowrap",
                      }}
                    >
                      ½ Half Day: {totalHalfday}
                    </span>
                  </div>
                </div>

                {/* Current UPI ID */}
                <div
                  style={{
                    padding: isMobile ? 12 : 18,
                    borderRadius: 18,
                    background:
                      "linear-gradient(145deg, rgba(255,126,95,0.13), rgba(254,180,123,0.22))",
                    border: "1px solid rgba(255,126,95,0.18)",
                    backdropFilter: "blur(10px)",
                    boxShadow: "0 10px 25px rgba(255,126,95,0.22)",
                    color: "#4a2600",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontSize: isMobile ? 11 : 13,
                      opacity: 0.85,
                      fontWeight: 600,
                    }}
                  >
                    Current UPI ID
                  </p>

                  <div
                    style={{
                      marginTop: 14,
                      // background: "rgba(253, 252, 252, 0.85)",
                      background:
                      "linear-gradient(145deg, rgba(241, 110, 78, 0.13), rgba(254,180,123,0.22))",
                      padding: "10px 14px",
                      borderRadius: 14,
                      fontSize: isMobile ? 12 : 14,
                      fontWeight: 700,
                      textAlign: "center",
                      color: "#022c32",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 6,
                      wordBreak: "break-all",
                    }}
                  >
                    <span style={{ color: "#03b8b3" }}>
                      {currentUpi || "Not set"}
                    </span>
                  </div>
                </div>
              </div>

              {/*  ATTRACTIVE COMPACT GRAPH */}
              {/*  GRAPH + RIGHT SIDE SUMMARY (RESPONSIVE)  */}
              <div
                style={{
                  display: "flex",
                  flexDirection:
                    window.innerWidth <= 600
                      ? "column"
                      : window.innerWidth <= 1024
                      ? "column"
                      : "row",
                  gap: isMobile ? 12 : 18,
                  alignItems: "stretch",
                  marginTop: 18,
                }}
              >
                {/* LEFT: ATTRACTIVE COMPACT GRAPH (same UI as before) */}
                <div
                  style={{
                    padding: "22px",
                    background: "rgba(255, 255, 255, 0.55)",
                    borderRadius: "22px",
                    backdropFilter: "blur(14px)",
                    WebkitBackdropFilter: "blur(14px)",
                    border: "1px solid rgba(255,255,255,0.4)",
                    boxShadow: "0px 12px 32px rgba(0,0,0,0.12)",
                    flex: 2,
                    minWidth: isMobile ? "85%" : 400,
                  }}
                >
                  <h3
                    style={{
                      color: "#022c32",
                      marginBottom: "18px",
                      textAlign: "center",
                      fontSize: "20px",
                      fontWeight: "700",
                      background: "linear-gradient(120deg, #03b8b3, #0489d4)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      letterSpacing: "0.5px",
                    }}
                  >
                    📊 Last 5 Days Sales Overview
                  </h3>

                  <div
                    style={{
                      height: window.innerWidth <= 600 ? "180px" : "250px",
                      padding: "6px",
                    }}
                  >
                    <Bar
                      data={{
                        labels: weeklySales.slice(2).map((d) => d[0].slice(5)),
                        datasets: [
                          {
                            data: weeklySales.slice(2).map((d) => d[1]),
                            backgroundColor: (ctx) => {
                              const chart = ctx.chart;
                              const { ctx: canvas } = chart;
                              const gradient = canvas.createLinearGradient(
                                0,
                                0,
                                0,
                                200
                              );
                              gradient.addColorStop(0, "rgba(3,184,179,0.9)");
                              gradient.addColorStop(1, "rgba(3,184,179,0.15)");
                              return gradient;
                            },
                            borderRadius: 12,
                            barThickness: "flex",
                            maxBarThickness: 42,
                          },
                        ],
                      }}
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: { legend: { display: false } },
                        scales: {
                          x: {
                            grid: { display: false },
                            ticks: {
                              color: "#044045",
                              font: { size: 12, weight: "600" },
                            },
                          },
                          y: {
                            beginAtZero: true,
                            grid: { color: "rgba(0,0,0,0.05)" },
                            ticks: {
                              font: { size: 12, weight: "600" },
                              color: "#044045",
                            },
                          },
                        },
                      }}
                    />
                  </div>
                </div>

                {/* RIGHT: SUMMARY PANEL LIKE "TOP SKILLS DETECTED" */}
                <div
                  style={{
                    flex: 1,
                    borderRadius: 22,
                    padding: isMobile ? 16 : 20,
                    background:
                      "radial-gradient(circle at top left, #e3f8ff 0%, #f3f6ff 40%, #fdfbff 100%)",
                    boxShadow: "0 10px 28px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(189,208,255,0.5)",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    minWidth: isMobile ? "90%" : 260,
                  }}
                >
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 10,
                      }}
                    >
                      <h3
                        style={{
                          margin: 0,
                          fontSize: 15,
                          fontWeight: 700,
                          color: "#1b3554",
                        }}
                      >
                        Quick Snapshot
                      </h3>
                      <span
                        style={{
                          fontSize: 11,
                          padding: "3px 8px",
                          borderRadius: 999,
                          background: "rgba(3,184,179,0.08)",
                          color: "#02a39c",
                          fontWeight: 600,
                        }}
                      >
                        Today / This Month
                      </span>
                    </div>

                    {/* Little “donut feel” circle in centre */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        margin: "8px 0 14px",
                      }}
                    >
                      <div
                        style={{
                          width: 90,
                          height: 90,
                          borderRadius: "50%",
                          background:
                            "conic-gradient(#03b8b3 0 25%, #ff8c42 25% 45%, #1e88e5 45% 65%, #2ecc71 65% 85%, #9b59b6 85% 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            width: 48,
                            height: 48,
                            borderRadius: "50%",
                            background: "#ffffff",
                            boxShadow: "0 0 0 4px rgba(255,255,255,0.4)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 11,
                            fontWeight: 700,
                            color: "#1b3554",
                          }}
                        >
                          {
                            customers.filter((c) => c.status !== "inactive")
                              .length
                          }
                        </div>
                      </div>
                    </div>

                    {/* LEGEND LINES (6 items – taken from your cards) */}
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr",
                        rowGap: 6,
                        fontSize: 12,
                        color: "#374865",
                      }}
                    >
                      {/* 1. Active Customers */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        <span
                          style={{
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            background: "#03b8b3",
                          }}
                        />
                        <span style={{ flex: 1 }}>Active Customers</span>
                        <strong>
                          {
                            customers.filter((c) => c.status !== "inactive")
                              .length
                          }
                        </strong>
                      </div>

                      {/* 2. Sales This Month */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        <span
                          style={{
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            background: "#1e88e5",
                          }}
                        />
                        <span style={{ flex: 1 }}>Sales This Month</span>
                        <strong>₹{globalMonthSales.toFixed(0)}</strong>
                      </div>

                      {/* 3. Today Sales */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        <span
                          style={{
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            background: "#ff8c42",
                          }}
                        />
                        <span style={{ flex: 1 }}>Today&apos;s Sales</span>
                        <strong>₹{globalTodaySales.toFixed(0)}</strong>
                      </div>

                      {/* 4. Employees */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        <span
                          style={{
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            background: "#9b59b6",
                          }}
                        />
                        <span style={{ flex: 1 }}>Employees</span>
                        <strong>{employees.length}</strong>
                      </div>

                      {/* 5. Attendance summary (Present + Absent) */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        <span
                          style={{
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            background: "#2ecc71",
                          }}
                        />
                        <span style={{ flex: 1 }}>Present / Absent</span>
                        <strong>
                          {totalPresent}/{totalAbsent}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

        {/* SALES REVIEW TABLE */}

        {showSales && (
          <div
            style={{
              background: "#fff",
              borderRadius: 12,
              boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
              padding: isMobile ? 12 : 20,
            }}
          >
            {/* Heading */}
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <CurrencyRupeeIcon
                style={{
                  color: "#022c32",
                  fontSize: isMobile ? "18px" : "24px",
                  marginRight: "2px",
                }}
              />
              <p
                style={{
                  color: "#022c32",
                  fontSize: isMobile ? "14px" : "16px",
                }}
              >
                Monthly Sales Review
              </p>
            </div>

            {/* Month Selector */}
            <div
              style={{
                marginBottom: 15,
                display: "flex",
                gap: 10,
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              {/* Month Dropdown */}
              <select
                value={selectedMonth.split(" ")[0] || ""}
                onChange={(e) => {
                  const month = e.target.value;
                  const year =
                    selectedMonth.split(" ")[1] || new Date().getFullYear();
                  setSelectedMonth(`${month} ${year}`);
                }}
                style={{
                  padding: isMobile ? "6px 8px" : "8px 12px",
                  borderRadius: 8,
                  border: "1px solid #bcd6db",
                  outline: "none",
                  fontWeight: 500,
                  cursor: "pointer",
                  flex: "1 1 150px",
                  fontSize: isMobile ? "12px" : "14px",
                  minWidth: 120,
                }}
              >
                <option value="">-- Select Month --</option>
                {[
                  "Jan",
                  "Feb",
                  "Mar",
                  "Apr",
                  "May",
                  "Jun",
                  "Jul",
                  "Aug",
                  "Sep",
                  "Oct",
                  "Nov",
                  "Dec",
                ].map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>

              {/* Year Dropdown */}
              <select
                value={selectedMonth.split(" ")[1] || new Date().getFullYear()}
                onChange={(e) => {
                  const year = e.target.value;
                  const month = selectedMonth.split(" ")[0] || "";
                  setSelectedMonth(`${month} ${year}`);
                }}
                style={{
                  padding: isMobile ? "6px 8px" : "8px 12px",
                  borderRadius: 8,
                  border: "1px solid #bcd6db",
                  outline: "none",
                  fontWeight: 500,
                  cursor: "pointer",
                  flex: "1 1 150px",
                  fontSize: isMobile ? "12px" : "14px",
                  minWidth: 120,
                }}
              >
                <option value="">-- Select Year --</option>
                {Array.from(
                  { length: 5 },
                  (_, i) => new Date().getFullYear() - 2 + i
                ).map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            {/* Table */}
            {selectedMonth && (
              <>
                {monthlyData.length > 0 ? (
                  <div
                    style={{
                      maxHeight: isMobile ? "300px" : "400px",
                      overflowY: "auto",
                      overflowX: "auto",
                      borderRadius: "8px",
                      border: "1px solid #e0e0e0",
                      marginTop: "10px",
                      scrollBehavior: "smooth",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        textAlign: "left",
                        minWidth: "600px",
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            background: "#03b8b3",
                            color: "#fff",
                            textTransform: "uppercase",
                            position: "sticky",
                            top: 0,
                            zIndex: 5,
                          }}
                        >
                          {[
                            "User ID",
                            "Name",
                            "Jar Qty",
                            "Capsule Qty",
                            "Total Price (₹)",
                            "status",
                          ].map((col) => (
                            <th
                              key={col}
                              style={{
                                padding: isMobile ? "6px 4px" : "10px 8px",
                                textAlign: "center",
                                fontSize: isMobile ? "11px" : "14px",
                              }}
                            >
                              {col}
                            </th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {monthlyData.map((item, i) => (
                          <tr key={i}>
                            <td style={tdStyle}>{item.userId}</td>
                            <td style={tdStyle}>{item.name}</td>
                            <td style={tdStyle}>{item.jarQty}</td>
                            <td style={tdStyle}>{item.capsuleQty}</td>
                            <td style={tdStyle}>
                              ₹{item.totalPrice.toFixed(2)}
                            </td>
                            <td style={tdStyle}>
                              {item.status === "SUCCESS" && (
                                <span
                                  style={{
                                    background: "#e6fff5",
                                    color: "#0a7d4f",
                                    padding: "4px 10px",
                                    borderRadius: "20px",
                                    fontWeight: "700",
                                    fontSize: isMobile ? "11px" : "13px",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  ✅ DONE
                                </span>
                              )}

                              {item.status === "PENDING" && (
                                <span
                                  style={{
                                    background: "#fff6e5",
                                    color: "#ff9800",
                                    padding: "4px 10px",
                                    borderRadius: "20px",
                                    fontWeight: "700",
                                    fontSize: isMobile ? "11px" : "13px",
                                  }}
                                >
                                  ⏳ Pending
                                </span>
                              )}

                              {item.status === "REJECTED" && (
                                <span
                                  style={{
                                    background: "#ffecec",
                                    color: "#d32f2f",
                                    padding: "4px 10px",
                                    borderRadius: "20px",
                                    fontWeight: "700",
                                    fontSize: isMobile ? "11px" : "13px",
                                  }}
                                >
                                  ❌ Rejected
                                </span>
                              )}

                              {!item.status && (
                                <span
                                  style={{
                                    background: "#f1f1f1",
                                    color: "#777",
                                    padding: "4px 10px",
                                    borderRadius: "20px",
                                    fontWeight: "700",
                                    fontSize: isMobile ? "11px" : "13px",
                                  }}
                                >
                                  ⚪ Unpaid
                                </span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p style={{ textAlign: "center", color: "#555" }}>
                    No sales data found for <b>{selectedMonth}</b>.
                  </p>
                )}
              </>
            )}
          </div>
        )}

        {/*view All Customers Table */}
        {showAll && (
          <div
            style={{
              background: "#fff",
              borderRadius: isMobile ? 8 : 12,
              boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
              padding: isMobile ? 12 : 20,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                color: "#022c32",
              }}
            >
              <PeopleAltIcon style={{ fontSize: isMobile ? 20 : 26 }} />
              <h3
                style={{
                  color: "#022c32",
                  marginBottom: isMobile ? 10 : 15,
                  fontSize: isMobile ? "16px" : "20px",
                }}
              >
                All Customers ({customers.length})
              </h3>
            </div>

            {customers.length > 0 ? (
              <div
                style={{
                  overflowX: "auto",
                  overflowY: "auto",
                  maxHeight: isMobile ? "300px" : "420px",
                  borderRadius: "8px",
                  border: "1px solid #e0e0e0",
                  marginTop: "8px",
                  scrollBehavior: "smooth",
                  scrollbarWidth: "thin",
                  scrollbarColor: "#c1c1c1 transparent",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    textAlign: "left",
                    minWidth: "600px",
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        background: "#03b8b3",
                        color: "#fff",
                        textTransform: "uppercase",
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                      }}
                    >
                      {["Date", "ID", "Name", "Mobile", "Address"].map(
                        (col) => (
                          <th
                            key={col}
                            style={{
                              padding: isMobile ? "6px 4px" : "10px 8px",
                              textAlign: "center",
                              fontSize: isMobile ? "11px" : "14px",
                            }}
                          >
                            {col}
                          </th>
                        )
                      )}
                    </tr>
                  </thead>

                  <tbody>
                    {customers
                      .filter((c) => c.status !== "inactive")
                      .map((c) => (
                        <tr
                          key={c.firebaseKey}
                          onClick={() => handleSelectCustomer(c)}
                          style={{ cursor: "pointer", transition: "0.2s" }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = "#f4f9f9")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.background = "transparent")
                          }
                        >
                          <td
                            style={{
                              ...tdStyle,
                              fontSize: isMobile ? "11px" : "14px",
                            }}
                          >
                            <CalendarMonthIcon
                              style={{
                                marginRight: 6,
                                color: "#03b8b3",
                                fontSize: isMobile ? 14 : 18,
                              }}
                            />
                            {c.joiningDate}
                          </td>

                          <td
                            style={{
                              ...tdStyle,
                              fontSize: isMobile ? "11px" : "14px",
                            }}
                          >
                            <FaIdCard
                              style={{ marginRight: 6, color: "#03b8b3" }}
                            />
                            {c.userId}
                          </td>

                          <td
                            style={{
                              ...tdStyle,
                              fontSize: isMobile ? "11px" : "14px",
                            }}
                          >
                            <FaUser
                              style={{ marginRight: 6, color: "#03b8b3" }}
                            />
                            {c.name}
                          </td>

                          <td
                            style={{
                              ...tdStyle,
                              fontSize: isMobile ? "11px" : "14px",
                            }}
                          >
                            <FaPhone
                              style={{ marginRight: 6, color: "#03b8b3" }}
                            />
                            {c.contact}
                          </td>

                          <td
                            style={{
                              ...tdStyle,
                              fontSize: isMobile ? "11px" : "14px",
                            }}
                          >
                            <FaMapMarkerAlt
                              style={{ marginRight: 6, color: "#03b8b3" }}
                            />
                            {c.address}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p style={{ textAlign: "center", color: "#555" }}>
                No customers found.
              </p>
            )}
          </div>
        )}

        {/*View All Bookings Table */}
        {showBookings && !showAll && !showSales && (
          <div
            style={{
              background: "#fff",
              borderRadius: 12,
              boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
              padding: 20,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                color: "#022c32",
              }}
            >
              <AddIcon />
              <h3 style={{ color: "#022c32", marginBottom: 15 }}>
                All Bookings ({bookings.length})
              </h3>
            </div>

            {bookings.length > 0 ? (
              <div
                style={{
                  overflowX: "auto",
                  overflowY: bookings.length > 10 ? "scroll" : "hidden",
                  maxHeight: bookings.length > 10 ? "420px" : "auto",
                  borderRadius: "8px",
                  border: "1px solid #e0e0e0",
                  marginTop: "8px",
                  scrollBehavior: "smooth",
                  scrollbarWidth: "thin",
                  scrollbarColor: "#c1c1c1 transparent",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    textAlign: "left",
                    minWidth: "600px",
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        background: "#03b8b3",
                        color: "#fff",
                        textTransform: "uppercase",
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                      }}
                    >
                      {[
                        "Date",
                        "Time",
                        "Name",
                        "Contact",
                        "Service",
                        "Jars",
                        "Capsules",
                        "Address",
                      ].map((col) => (
                        <th
                          key={col}
                          style={{
                            padding: "10px 8px",
                            background: "#03b8b3",
                            position: "sticky",
                            top: 0,
                            zIndex: 3,
                            textAlign: "center",
                          }}
                        >
                          {col}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {bookings.map((b, i) => (
                      <tr
                        key={i}
                        style={{
                          cursor: "default",
                          transition: "0.2s",
                          alignItems: "center",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#f4f9f9")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "transparent")
                        }
                      >
                        <td style={tdStyle}>{b.date}</td>
                        <td style={tdStyle}>{b.time || "-"}</td>
                        <td style={tdStyle}>{b.userName}</td>
                        <td style={tdStyle}>{b.contact}</td>
                        <td style={tdStyle}>{b.service}</td>
                        <td style={tdStyle}>{b.jars}</td>
                        <td style={tdStyle}>{b.capsules}</td>
                        <td style={tdStyle}>{b.address}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p style={{ textAlign: "center", color: "#555" }}>
                No bookings found.
              </p>
            )}
          </div>
        )}

        {showEmployeeModal && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.45)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 200,
            }}
          >
            <div
              style={{
                background: "#fff",
                padding: 20,
                borderRadius: 12,
                width: "100%",
                maxWidth: 350,
                boxShadow: "0 8px 22px rgba(0,0,0,0.3)",
              }}
            >
              <h3
                style={{
                  textAlign: "center",
                  marginBottom: 15,
                  fontWeight: 700,
                  color: "#022c32",
                }}
              >
                Add New Employee
              </h3>

              {/* EMPLOYEE ID */}
              <label style={labelStyle}>Employee ID:</label>
              <input
                value={employeeData.empId}
                disabled
                style={{
                  ...inputStyle,
                  background: "#e7f6f6",
                  fontWeight: "bold",
                }}
              />

              {/* NAME */}
              <label style={labelStyle}>Full Name:</label>
              <input
                type="text"
                value={employeeData.name}
                onChange={(e) =>
                  setEmployeeData({ ...employeeData, name: e.target.value })
                }
                style={inputStyle}
                placeholder="Enter employee name"
              />

              {/* CONTACT */}
              <label style={labelStyle}>Contact Number:</label>
              <input
                type="number"
                value={employeeData.contact}
                onChange={(e) =>
                  setEmployeeData({ ...employeeData, contact: e.target.value })
                }
                style={inputStyle}
                placeholder="Enter mobile number"
              />

              {/* ADDRESS */}
              <label style={labelStyle}>Address:</label>
              <input
                type="text"
                value={employeeData.address}
                onChange={(e) =>
                  setEmployeeData({ ...employeeData, address: e.target.value })
                }
                style={inputStyle}
                placeholder="Enter address"
              />

              {/* JOINING DATE */}
              <label style={labelStyle}>Joining Date:</label>
              <input
                type="date"
                value={employeeData.joiningDate}
                onChange={(e) =>
                  setEmployeeData({
                    ...employeeData,
                    joiningDate: e.target.value,
                  })
                }
                style={inputStyle}
              />

              {/* SALARY */}
              <label style={labelStyle}>Salary Per Day (₹):</label>
              <input
                type="number"
                value={employeeData.salaryPerDay}
                onChange={(e) =>
                  setEmployeeData({
                    ...employeeData,
                    salaryPerDay: e.target.value,
                  })
                }
                style={inputStyle}
                placeholder="Enter daily salary"
              />

              {/* BUTTONS */}
              <div style={{ display: "flex", marginTop: 15, gap: 10 }}>
                <button
                  onClick={editEmployeeId ? updateEmployee : saveEmployee}
                  disabled={
                    editEmployeeId &&
                    JSON.stringify(employeeData) ===
                      JSON.stringify(originalEmployeeData)
                  }
                  style={{
                    ...btnStyle,
                    opacity:
                      editEmployeeId &&
                      JSON.stringify(employeeData) ===
                        JSON.stringify(originalEmployeeData)
                        ? 0.5
                        : 1,
                    cursor:
                      editEmployeeId &&
                      JSON.stringify(employeeData) ===
                        JSON.stringify(originalEmployeeData)
                        ? "not-allowed"
                        : "pointer",
                    background: editEmployeeId
                      ? "linear-gradient(120deg,#f39c12,#e67e22)"
                      : "linear-gradient(120deg,#03b8b3,#04d4cd)",
                  }}
                >
                  {editEmployeeId ? "Update" : "Save"}
                </button>

                <button
                  onClick={closeEmployeeModal}
                  style={{
                    ...btnStyle,
                    background: "linear-gradient(120deg,#e53935,#ff5252)",
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Manage Employees Section */}

        {showEmployees &&
          !showAll &&
          !showSales &&
          !showBookings &&
          !showInactive &&
          !showDaily &&
          !selectedUser && (
            <div
              style={{
                background: "#fff",
                borderRadius: 12,
                boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
                padding: isMobile ? 12 : 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: isMobile ? "center" : "space-between",
                  alignItems: "center",
                  flexDirection: isMobile ? "column" : "row",
                  gap: isMobile ? 8 : 10,
                }}
              >
                <h3
                  style={{
                    color: "#022c32",
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    fontWeight: 700,
                    fontSize: isMobile ? "15px" : "18px",
                  }}
                >
                  <Groups2Icon style={{ fontSize: isMobile ? 22 : 26 }} />{" "}
                  Manage Employees
                </h3>

                <button
                  onClick={openEmployeeModal}
                  style={{
                    background: "linear-gradient(135deg, #03b8b3, #04d4cd)",
                    color: "#fff",
                    padding: isMobile ? "7px 12px" : "10px 18px",
                    fontSize: isMobile ? "0.8rem" : "1rem",
                    fontWeight: 600,
                    borderRadius: 10,
                    border: "none",
                    cursor: "pointer",
                    boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
                    width: isMobile ? "100%" : "auto",
                    textAlign: "center",
                  }}
                >
                  + Add New Employee
                </button>

                <button
                  onClick={() => {
                    const current = new Date().toISOString().slice(0, 7);
                    setAttendanceMonth(current);
                    setShowAttendanceUI(false);
                    setShowEmployees(false);
                    setShowAttendanceReportUI(true);
                    setShowAll(false);
                    setShowSales(false);
                    setShowBookings(false);
                    setShowInactive(false);
                    setShowDaily(false);
                    setSelectedUser("");
                  }}
                  style={{
                    background: "linear-gradient(135deg, #1e88e5, #42a5f5)",
                    color: "#fff",
                    padding: isMobile ? "7px 12px" : "10px 18px",
                    fontSize: isMobile ? "0.8rem" : "1rem",
                    fontWeight: 600,
                    borderRadius: 10,
                    border: "none",
                    cursor: "pointer",
                    marginLeft: isMobile ? 0 : 10,
                    boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
                    width: isMobile ? "100%" : "auto",
                    textAlign: "center",
                  }}
                >
                  📅 Monthly Report
                </button>

                <button
                  onClick={() => {
                    setShowAttendanceUI(true);
                    setShowEmployees(false);
                    setShowAll(false);
                    setShowSales(false);
                    setShowBookings(false);
                    setShowInactive(false);
                    setShowDaily(false);
                    setSelectedUser("");
                    setShowAttendanceReportUI(false);
                  }}
                  style={{
                    background: "linear-gradient(135deg, #2ecc71, #27ae60)",
                    color: "#fff",
                    padding: isMobile ? "7px 12px" : "10px 18px",
                    fontSize: isMobile ? "0.8rem" : "1rem",
                    fontWeight: 600,
                    borderRadius: 10,
                    border: "none",
                    cursor: "pointer",
                    marginLeft: isMobile ? 0 : 10,
                    boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
                    width: isMobile ? "100%" : "auto",
                    textAlign: "center",
                  }}
                >
                  📅 Attendance
                </button>
              </div>

              {employees.length === 0 ? (
                <p
                  style={{
                    color: "#777",
                    textAlign: "center",
                    marginTop: 20,
                    fontSize: isMobile ? "0.8rem" : "0.9rem",
                  }}
                >
                  No employees found. Add new employees to get started.
                </p>
              ) : (
                <div
                  style={{
                    overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: isMobile ? "260px" : "410px",
                    border: "1px solid #e0e0e0",
                    borderRadius: "10px",
                    marginTop: "15px",
                    scrollbarWidth: "thin",
                    scrollBehavior: "smooth",
                    scrollbarColor: "#c1c1c1 transparent",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      minWidth: isMobile ? "520px" : "600px",
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          background: "#03b8b3",
                          color: "#fff",
                          textTransform: "uppercase",
                          position: "sticky",
                          top: 0,
                        }}
                      >
                        {[
                          "Emp ID",
                          "Name",
                          "Mobile",
                          "Address",
                          "Joining Date",
                          "Salary/Day",
                          "Actions",
                        ].map((h) => (
                          <th
                            key={h}
                            style={{
                              padding: isMobile ? 6 : 10,
                              textAlign: "center",
                              fontSize: isMobile ? 11 : 13,
                            }}
                          >
                            {h}
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {employees.map((emp) => (
                        <tr
                          key={emp.firebaseKey}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            if (!attendanceMonth) {
                              setAttendanceMonth(
                                new Date().toISOString().slice(0, 7)
                              );
                            }
                            openCalendarModal(emp);
                          }}
                        >
                          <td style={tdStyle}>{emp.empId}</td>
                          <td style={tdStyle}>{emp.name}</td>
                          <td style={tdStyle}>{emp.contact}</td>
                          <td style={tdStyle}>{emp.address}</td>
                          <td style={tdStyle}>{emp.joiningDate}</td>
                          <td style={tdStyle}>₹{emp.salaryPerDay}</td>
                          <td
                            style={{
                              ...tdStyle,
                              display: "flex",
                              gap: isMobile ? 4 : 8,
                              justifyContent: "center",
                            }}
                          >
                            {/* Edit Button */}
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEditEmployee(emp);
                              }}
                              style={{
                                background:
                                  "linear-gradient(120deg, #3498db, #2ecc71)",
                                color: "#fff",
                                border: "none",
                                padding: isMobile ? "4px 8px" : "6px 10px",
                                borderRadius: 6,
                                cursor: "pointer",
                                fontWeight: 600,
                                fontSize: isMobile ? "0.7rem" : "0.8rem",
                              }}
                            >
                              Edit
                            </button>

                            {/* Delete Button */}
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteEmployee(emp.firebaseKey);
                              }}
                              style={{
                                background:
                                  "linear-gradient(120deg, #e74c3c, #c0392b)",
                                color: "#fff",
                                border: "none",
                                padding: isMobile ? "4px 8px" : "6px 10px",
                                borderRadius: 6,
                                cursor: "pointer",
                                fontWeight: 600,
                                fontSize: isMobile ? "0.7rem" : "0.8rem",
                              }}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

        {/* ---- DAILY ATTENDANCE SECTION ---- */}

        {showAttendanceUI && (
          <>
            <div
              style={{
                background: "#03b8b3",
                height: 40,
                cursor: "pointer",
                width: 40,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
              }}
              onClick={() => {
                setShowAttendanceUI(false);
                setShowEmployees(true);
                setShowInactive(false);
                setShowAll(false);
                setShowSales(false);
                setShowBookings(false);
                setShowAttendanceReportUI(false);
                setSelectedUser("");
                setShowDaily(false);
              }}
            >
              <KeyboardArrowLeftIcon style={{ color: "white" }} />
            </div>

            <h3
              style={{
                marginTop: 30,
                fontWeight: 700,
                color: "#022c32",
                display: "flex",
                alignItems: "center",
                gap: 8,
                fontSize: isMobile ? "16px" : "20px",
              }}
            >
              🗓 Daily Attendance
            </h3>

            {/* ---- FILTER DROPDOWN ---- */}
            <div
              style={{
                marginTop: 10,
                marginBottom: 12,
                display: "flex",
                justifyContent: isMobile ? "center" : "flex-start",
              }}
            >
              <div
                style={{
                  position: "relative",
                  width: isMobile ? "90%" : "220px",
                }}
              >
                <select
                  value={attendanceFilter}
                  onChange={(e) => setAttendanceFilter(e.target.value)}
                  style={{
                    padding: isMobile ? "8px 12px" : "10px 16px",
                    borderRadius: 10,
                    border: "1px solid #c6dede",
                    fontSize: isMobile ? "0.9rem" : "1rem",
                    fontWeight: 600,
                    cursor: "pointer",
                    background: "#fff",
                    color: "#022c32",
                    width: isMobile ? "90%" : "220px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
                    appearance: "none",
                  }}
                >
                  <option
                    value="all"
                    style={{
                      padding: "10px",
                      fontSize: "14px",
                      background: "#ffffff",
                      color: "#022c32",
                      fontWeight: 600,
                    }}
                  >
                    All
                  </option>

                  <option
                    value="present"
                    style={{
                      padding: "10px",
                      fontSize: "14px",
                      background: "#e9f8e9",
                      color: "#0b5f23",
                      fontWeight: 600,
                    }}
                  >
                    Present
                  </option>

                  <option
                    value="absent"
                    style={{
                      padding: "10px",
                      fontSize: "14px",
                      background: "#fdeaea",
                      color: "#a01010",
                      fontWeight: 600,
                    }}
                  >
                    Absent
                  </option>

                  <option
                    value="leave"
                    style={{
                      padding: "10px",
                      fontSize: "14px",
                      background: "#fff6de",
                      color: "#775d1e",
                      fontWeight: 600,
                    }}
                  >
                    Leave
                  </option>

                  <option
                    value="halfday"
                    style={{
                      padding: "10px",
                      fontSize: "14px",
                      background: "#e5f2ff",
                      color: "#0a4371",
                      fontWeight: 600,
                    }}
                  >
                    Half Day
                  </option>

                  <option
                    value="none"
                    style={{
                      padding: "10px",
                      fontSize: "14px",
                      background: "#f2f2f2",
                      color: "#555",
                      fontWeight: 600,
                    }}
                  >
                    Unfilled
                  </option>
                </select>
                <div
                  style={{
                    position: "absolute",
                    right: isMobile ? 33 : isTablet ? 8 : 15,
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    fontSize: isMobile ? 18 : 20,
                    color: "#03b8b3",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <KeyboardArrowDownIcon
                    style={{
                      fontSize: isMobile ? "20px" : "24px",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* ---- STATUS SUMMARY BADGES ---- */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(4, auto)",
                gap: isMobile ? 8 : 12,
                marginTop: 5,
                marginBottom: 12,
                justifyContent: isMobile ? "center" : "flex-start",
                alignItems: "center",
              }}
            >
              {/* Present */}
              <div
                style={{
                  background: "#c8f7c5",
                  padding: isMobile ? "6px 10px" : "8px 14px",
                  borderRadius: 8,
                  fontSize: isMobile ? "12px" : "14px",
                  color: "#03340f",
                  fontWeight: 700,
                  textAlign: "center",
                  boxShadow: "0 1px 5px rgba(0,0,0,0.15)",
                }}
              >
                Present: {totalPresent}
              </div>

              {/* Absent */}
              <div
                style={{
                  background: "#f7c5c5",
                  padding: isMobile ? "6px 10px" : "8px 14px",
                  borderRadius: 8,
                  fontSize: isMobile ? "12px" : "14px",
                  color: "#7a0c0c",
                  fontWeight: 700,
                  textAlign: "center",
                  boxShadow: "0 1px 5px rgba(0,0,0,0.15)",
                }}
              >
                Absent: {totalAbsent}
              </div>

              {/* Leave */}
              <div
                style={{
                  background: "#f7eac5",
                  padding: isMobile ? "6px 10px" : "8px 14px",
                  borderRadius: 8,
                  fontSize: isMobile ? "12px" : "14px",
                  color: "#7a5a11",
                  fontWeight: 700,
                  textAlign: "center",
                  boxShadow: "0 1px 5px rgba(0,0,0,0.15)",
                }}
              >
                Leave: {totalLeave}
              </div>

              {/* Half Day */}
              <div
                style={{
                  background: "#c5e0f7",
                  padding: isMobile ? "6px 10px" : "8px 14px",
                  borderRadius: 8,
                  fontSize: isMobile ? "12px" : "14px",
                  color: "#0a3c78",
                  fontWeight: 700,
                  textAlign: "center",
                  boxShadow: "0 1px 5px rgba(0,0,0,0.15)",
                }}
              >
                Half Day: {totalHalfday}
              </div>
            </div>

            <div
              style={{
                background: "#fff",
                borderRadius: 12,
                boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
                padding: isMobile ? 10 : 16,
                marginTop: 8,
              }}
            >
              <div
                style={{
                  overflowX: "auto",
                  overflowY: "auto",
                  maxHeight: isMobile ? "260px" : "320px",
                  borderRadius: 8,
                  border: "1px solid #e0e0e0",
                  scrollBehavior: "smooth",
                  scrollbarWidth: "thin",
                  scrollbarColor: "#c1c1c1 transparent",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: 0,
                    minWidth: isMobile ? "520px" : "600px",
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        background: "#03b8b3",
                        color: "#fff",
                        textTransform: "uppercase",
                        position: "sticky",
                        top: 0,
                        zIndex: "5",
                      }}
                    >
                      {[
                        "Emp Id",
                        "Name",
                        "Mobile",
                        "Salary/Day",
                        "Status",
                        "Mark Attendance",
                      ].map((h) => (
                        <th
                          key={h}
                          style={{
                            ...tdStyle,
                            fontWeight: 600,
                            fontSize: isMobile ? 11 : 13,
                          }}
                        >
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {employees
                      .filter((emp) => {
                        const status =
                          attendanceData[today]?.[emp.empId]?.status || "none";

                        if (attendanceFilter === "all") return true;

                        return status === attendanceFilter;
                      })
                      .map((emp) => (
                        <tr key={emp.firebaseKey}>
                          <td style={tdStyle}>{emp.empId}</td>
                          <td style={tdStyle}>{emp.name}</td>
                          <td style={tdStyle}>{emp.contact}</td>
                          <td style={tdStyle}>₹{emp.salaryPerDay}</td>

                          {/* NEW STATUS COLUMN */}
                          <td style={tdStyle}>
                            {attendanceData[today]?.[emp.empId]?.status ? (
                              <span
                                style={{
                                  padding: "4px 8px",
                                  background: "#c8f7c5", // green
                                  borderRadius: 6,
                                  fontSize: isMobile ? "0.7rem" : "0.8rem",
                                  fontWeight: 600,
                                  color: "#022c32",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {attendanceData[today][
                                  emp.empId
                                ].status.toUpperCase()}
                              </span>
                            ) : (
                              <span
                                style={{
                                  padding: "4px 8px",
                                  background: "#f7c5c5", // red
                                  borderRadius: 6,
                                  fontSize: isMobile ? "0.7rem" : "0.8rem",
                                  fontWeight: 600,
                                  color: "#c62828",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                UNFILLED
                              </span>
                            )}
                          </td>

                          {/* MARK ATTENDANCE COLUMN */}
                          <td style={tdStyle}>
                            <button
                              onClick={() => {
                                setSelectedEmpForAttendance(emp);
                                setAttendanceStatus("");
                                setShowAttendanceModal(true);
                              }}
                              style={{
                                background:
                                  "linear-gradient(120deg, #3498db, #8e44ad)",
                                color: "#fff",
                                padding: isMobile ? "4px 8px" : "6px 12px",
                                borderRadius: 6,
                                fontWeight: 600,
                                border: "none",
                                cursor: "pointer",
                                fontSize: isMobile ? "0.75rem" : "0.85rem",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Mark Attendance
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}

        {showAttendanceReportUI && (
          <>
            <div
              style={{
                background: "#03b8b3",
                height: 40,
                cursor: "pointer",
                width: 40,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
              }}
              onClick={() => {
                setShowAttendanceUI(false);
                setShowEmployees(true);
                setShowInactive(false);
                setShowAll(false);
                setShowSales(false);
                setShowBookings(false);
                setShowAttendanceReportUI(false);
                setSelectedUser("");
                setShowDaily(false);
              }}
            >
              <KeyboardArrowLeftIcon style={{ color: "white" }} />
            </div>

            <h3
              style={{
                marginTop: 30,
                fontWeight: 700,
                color: "#022c32",
                display: "flex",
                gap: 8,
                fontSize: isMobile ? "15px" : "18px",
              }}
            >
              📆 Monthly Attendance Report
            </h3>

            <div
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                alignItems: isMobile ? "stretch" : "center",
                gap: "12px",
                width: "100%",
                marginBottom: 16,
              }}
            >
              <input
                type="month"
                value={attendanceMonth}
                onChange={(e) => setAttendanceMonth(e.target.value)}
                style={{
                  padding: isMobile ? "10px 12px" : "8px 12px",
                  borderRadius: 8,
                  border: "1px solid #bcd6db",
                  fontWeight: 600,
                  fontSize: isMobile ? "0.9rem" : "0.9rem",
                  width: isMobile ? "90%" : "auto",
                }}
              />

              <button
                onClick={downloadMonthlyAttendanceExcel}
                style={{
                  background: "linear-gradient(135deg, #04b870, #02d18f)",
                  color: "#fff",
                  border: "none",
                  padding: isMobile ? "12px" : "8px 16px",
                  borderRadius: 8,
                  fontWeight: 600,
                  cursor: "pointer",
                  width: isMobile ? "100%" : "auto",
                  whiteSpace: "nowrap",
                }}
              >
                📥 Download Excel
              </button>
            </div>

            {attendanceReport.length > 0 ? (
              <div
                style={{
                  background: "#fff",
                  borderRadius: 12,
                  boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
                  padding: isMobile ? 10 : 16,
                }}
              >
                <div
                  style={{
                    overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: isMobile ? "260px" : "320px",
                    borderRadius: 8,
                    border: "1px solid #e0e0e0",
                    scrollBehavior: "smooth",
                    scrollbarWidth: "thin",
                    scrollbarColor: "#c1c1c1 transparent",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      minWidth: isMobile ? "520px" : "600px",
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          background: "#03b8b3",
                          color: "#fff",
                          textTransform: "uppercase",
                          position: "sticky",
                          top: 0,
                          zIndex: "5",
                        }}
                      >
                        {[
                          "Emp ID",
                          "Name",
                          "Present",
                          "Absent",
                          "Half Day",
                          "Leave",
                          "Total Salary (₹)",
                        ].map((h) => (
                          <th
                            key={h}
                            style={{
                              ...tdStyle,
                              fontWeight: 600,
                              fontSize: isMobile ? 11 : 13,
                            }}
                          >
                            {h}
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {attendanceReport.map((emp, i) => (
                        <tr
                          key={i}
                          style={{ cursor: "pointer" }}
                          onClick={() => openCalendarModal(emp)}
                        >
                          <td style={tdStyle}>{emp.empId}</td>
                          <td style={tdStyle}>{emp.name}</td>
                          <td style={tdStyle}>{emp.present}</td>
                          <td style={tdStyle}>{emp.absent}</td>
                          <td style={tdStyle}>{emp.halfday}</td>
                          <td style={tdStyle}>{emp.leave}</td>
                          <td style={tdStyle}>
                            ₹
                            {emp.present * emp.salary +
                              emp.halfday * (emp.salary / 2)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <p
                style={{
                  color: "#777",
                  fontSize: isMobile ? "0.8rem" : "0.9rem",
                }}
              >
                Select month to view attendance.
              </p>
            )}
          </>
        )}

        {showCalendarModal && selectedCalendarEmp && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.45)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 2000,
            }}
          >
            <div
              style={{
                width: "95%",
                maxWidth: isMobile ? 340 : 420,
                background: "#fff",
                padding: isMobile ? 14 : 20,
                borderRadius: 12,
              }}
            >
              <h3
                style={{
                  textAlign: "center",
                  marginBottom: 10,
                  color: "#022c32",
                  fontSize: isMobile ? "15px" : "17px",
                }}
              >
                {selectedCalendarEmp.name} – Attendance Calendar
              </h3>

              {/* Calendar Grid */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(7, 1fr)",
                  gap: isMobile ? 6 : 8,
                }}
              >
                {calendarData.map((d, i) => (
                  <div
                    key={i}
                    style={{
                      padding: isMobile ? "6px 3px" : "8px 4px",
                      borderRadius: 8,
                      textAlign: "center",
                      fontSize: isMobile ? 10 : 12,
                      fontWeight: 600,
                      background:
                        d.status === "present"
                          ? "#c8f7c5"
                          : d.status === "absent"
                          ? "#f7c5c5"
                          : d.status === "leave"
                          ? "#f7eac5"
                          : d.status === "halfday"
                          ? "#c5e0f7"
                          : "#efefef",
                      color: d.status === "none" ? "#777" : "#022c32",
                      border: "1px solid #ddd",
                    }}
                  >
                    {d.date.split("-")[2]}{" "}
                    <div style={{ fontSize: isMobile ? 9 : 10 }}>
                      {d.status === "none" ? "-" : d.status}
                    </div>
                  </div>
                ))}
              </div>

              <button
                onClick={() => setShowCalendarModal(false)}
                style={{
                  marginTop: 15,
                  width: "100%",
                  padding: isMobile ? "8px" : "10px",
                  background: "linear-gradient(120deg,#e53935,#ff5252)",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  fontWeight: 700,
                  cursor: "pointer",
                  fontSize: isMobile ? "0.85rem" : "0.95rem",
                }}
              >
                Close
              </button>
            </div>
          </div>
        )}

        {showPaymentRequests && (
          <div style={{ padding: 20 }}>
            <h2
              style={{
                marginBottom: 15,
                display: "flex",
                alignItems: "center",
                gap: 6,
                fontSize: isMobile ? "16px" : "24px",
                color: "#03b8b3",
              }}
            >
              <CurrencyRupeeIcon
                style={{
                  fontSize: isMobile ? "16px" : "24px",
                  color: "#03b8b3",
                }}
              />
              Pending Payment Requests
            </h2>

            {paymentRequests.length === 0 ? (
              <p style={{ marginLeft: "2.5%" }}>No pending requests</p>
            ) : (
              <div style={{ overflowX: "auto" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    background: "#fff",
                    borderRadius: 12,
                    overflow: "hidden",
                    boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
                  }}
                >
                  <thead
                    style={{
                      background: "linear-gradient(120deg, #03b8b3, #04d4cd)",
                      color: "#fff",
                    }}
                  >
                    <tr>
                      <th style={thStyle}>Date</th>
                      <th style={thStyle}>User ID</th>
                      <th style={thStyle}>User Name</th>
                      <th style={thStyle}>Payment Month</th>
                      <th style={thStyle}>Amount (₹)</th>
                      {/* <th style={thStyle}>Status</th> */}
                      <th style={thStyle}>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {paymentRequests.map((p, i) => (
                      <tr
                        key={i}
                        style={{
                          borderBottom: "1px solid #eee",
                          textAlign: "center",
                        }}
                      >
                        <td style={tdStyle}>
                          {p.paymentDate
                            ? new Date(p.paymentDate).toLocaleDateString(
                                "en-IN",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                }
                              )
                            : "-"}
                        </td>
                        <td style={tdStyle}>{p.userId}</td>
                        <td style={tdStyle}>{p.userName}</td>
                        <td style={tdStyle}>{p.month}</td>
                        <td style={tdStyle}>₹{p.amount}</td>

                        <td style={tdStyle}>
                          {p.status === "PENDING" ? (
                            <div
                              style={{
                                display: "flex",
                                gap: 6,
                                justifyContent: "center",
                              }}
                            >
                              <button
                                onClick={() =>
                                  setConfirmAction({
                                    open: true,
                                    type: "UPI",
                                    row: p,
                                  })
                                }
                                style={paidBtn}
                              >
                                UPI Payment
                              </button>

                              <button
                                onClick={() =>
                                  setConfirmAction({
                                    open: true,
                                    type: "CASH",
                                    row: p,
                                  })
                                }
                                style={unpaidBtn}
                              >
                                Cash Payment
                              </button>

                              <button
                                onClick={() =>
                                  setConfirmAction({
                                    open: true,
                                    type: "REJECT",
                                    row: p,
                                  })
                                }
                                style={rejectBtn}
                              >
                                Reject
                              </button>
                            </div>
                          ) : (
                            <span
                              style={{
                                fontWeight: 700,
                                color:
                                  p.status === "PAID"
                                    ? "green"
                                    : p.status === "REJECTED"
                                    ? "red"
                                    : "#999",
                              }}
                            >
                              {p.status === "PAID"
                                ? `PAID (${p.paidVia})`
                                : "REJECTED"}
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {confirmAction.open && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.45)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
              animation: "fadeIn 0.25s ease-out",
              boxShadow: "0 12px 30px rgba(0,0,0,0.25)",
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: 12,
                padding: 20,
                width: "80%",
                maxWidth: 360,
                textAlign: "center",
                boxShadow: "0 8px 25px rgba(0,0,0,0.25)",
                 animation: "popIn 0.3s cubic-bezier(0.25, 0.8, 0.3, 1)",
              }}
            >
              <h3 style={{ marginBottom: 10 }}>Confirm</h3>

              <p style={{ marginBottom: 20, color: "#555" }}>
                {confirmAction.type === "REJECT"
                  ? "Are you sure you want to reject this payment?"
                  : `Are you sure you want to mark payment as PAID via ${confirmAction.type}?`}
              </p>

              <div
                style={{ display: "flex", justifyContent: "center", gap: 10 }}
              >
                <button
                  onClick={() =>
                    setConfirmAction({ open: false, type: null, row: null })
                  }
                  style={{
                    padding: "8px 16px",
                    borderRadius: 6,
                    border: "1px solid #ccc",
                    background: "#fff",
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>

                <button
                  onClick={confirmYes}
                  style={{
                    padding: "8px 16px",
                    borderRadius: 6,
                    border: "none",
                    background:
                      confirmAction.type === "REJECT"
                        ? "#e53935"
                        : "linear-gradient(120deg, #03b8b3, #04d4cd)",
                    color: "#fff",
                    fontWeight: 700,
                    cursor: "pointer",
                  }}
                >
                  Yes, Confirm
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ⏸️ Inactive Customers Table */}
        {showInactive && !showAll && !showSales && !showBookings && (
          <div
            style={{
              background: "#fff",
              borderRadius: isMobile ? 8 : 12,
              boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
              padding: isMobile ? 12 : 20,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                color: "#022c32",
              }}
            >
              <PeopleAltIcon style={{ fontSize: isMobile ? "18px" : "24px" }} />
              <h3
                style={{
                  color: "#c62828",
                  marginBottom: isMobile ? 10 : 15,
                  fontSize: isMobile ? "16px" : "20px",
                }}
              >
                Inactive Customers (
                {customers.filter((u) => u.status === "inactive").length})
              </h3>
            </div>

            {customers.filter((u) => u.status === "inactive").length > 0 ? (
              <div
                style={{
                  overflowX: "auto",
                  overflowY: "auto",
                  maxHeight: isMobile ? "300px" : "420px",
                  borderRadius: "8px",
                  border: "1px solid #e0e0e0",
                  marginTop: "8px",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    textAlign: "left",
                    minWidth: "600px",
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        background: "#c62828",
                        color: "#fff",
                        textTransform: "uppercase",
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                        textAlign: "center",
                      }}
                    >
                      {[
                        "ID",
                        "Name",
                        "Mobile",
                        "Address",
                        "Inactive Date",
                        "Actions",
                      ].map((col) => (
                        <th
                          key={col}
                          style={{
                            padding: isMobile ? "6px 4px" : "10px 8px",
                            fontSize: isMobile ? "11px" : "14px",
                          }}
                        >
                          {col}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {customers
                      .filter((u) => u.status === "inactive")
                      .map((u) => (
                        <tr key={u.firebaseKey}>
                          <td
                            style={{ ...tdStyle, fontSize: isMobile ? 11 : 14 }}
                          >
                            {u.userId}
                          </td>
                          <td
                            style={{ ...tdStyle, fontSize: isMobile ? 11 : 14 }}
                          >
                            {u.name}
                          </td>
                          <td
                            style={{ ...tdStyle, fontSize: isMobile ? 11 : 14 }}
                          >
                            {u.contact}
                          </td>

                          <td
                            style={{ ...tdStyle, fontSize: isMobile ? 11 : 14 }}
                          >
                            {u.address}
                          </td>

                          <td
                            style={{ ...tdStyle, fontSize: isMobile ? 11 : 14 }}
                          >
                            {u.inactiveDate || "-"}
                          </td>

                          <td
                            style={{
                              ...tdStyle,
                              display: "flex",
                              gap: isMobile ? "4px" : "8px",
                              justifyContent: "center",
                            }}
                          >
                            <button
                              onClick={async () => {
                                const ok = window.confirm(
                                  `Activate "${u.name}" again?`
                                );
                                if (!ok) return;

                                try {
                                  await update(
                                    ref(db, "users/" + u.firebaseKey),
                                    {
                                      status: "active",
                                      inactiveDate: null,
                                    }
                                  );
                                  alert("✅ User Activated!");
                                } catch (err) {
                                  console.error(err);
                                  alert("❌ Activation failed");
                                }
                              }}
                              style={{
                                background:
                                  "linear-gradient(120deg, #28a745, #5cd67d)",
                                color: "#fff",
                                border: "none",
                                padding: isMobile ? "5px 8px" : "6px 12px",
                                borderRadius: 6,
                                cursor: "pointer",
                                fontWeight: 600,
                                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                fontSize: isMobile ? "11px" : "14px",
                                minWidth: isMobile ? "60px" : "80px",
                              }}
                            >
                              Activate
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p
                style={{
                  textAlign: "center",
                  color: "#888",
                  fontSize: isMobile ? "13px" : "15px",
                }}
              >
                No inactive customers found.
              </p>
            )}
          </div>
        )}

        {/* 📅 Daily Sales Report Section */}

        {showDaily &&
          !showAll &&
          !showBookings &&
          !showSales &&
          !showInactive && (
            <div
              style={{
                background: "#fff",
                borderRadius: isMobile ? 8 : 12,
                boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
                padding: isMobile ? 12 : 20,
              }}
            >
              <h3
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  color: "#022c32",
                  fontWeight: 700,
                  marginBottom: isMobile ? 10 : 15,
                  fontSize: isMobile ? "16px" : "20px",
                }}
              >
                <CurrencyRupeeIcon style={{ fontSize: isMobile ? 18 : 24 }} />
                Daily Sales Report
              </h3>

              {/* Date Selector */}
              <div
                style={{
                  display: "flex",
                  gap: isMobile ? 6 : 10,
                  marginBottom: isMobile ? 10 : 15,
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: isMobile ? "center" : "",
                  flexDirection: isMobile ? "column" : "row",
                }}
              >
                {/* FROM DATE */}
                <label
                  style={{
                    fontWeight: 600,
                    color: "#022c32",
                    fontSize: isMobile ? "13px" : "15px",
                  }}
                >
                  From:
                </label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  style={{
                    padding: isMobile ? "6px 10px" : "10px 14px",
                    borderRadius: 10,
                    border: "1px solid #bcd6db",
                    fontWeight: 600,
                    cursor: "pointer",
                    fontSize: isMobile ? "13px" : "15px",
                  }}
                />

                {/* TO DATE */}
                <label
                  style={{
                    fontWeight: 600,
                    color: "#022c32",
                    fontSize: isMobile ? "13px" : "15px",
                  }}
                >
                  To:
                </label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  style={{
                    padding: isMobile ? "6px 10px" : "10px 14px",
                    borderRadius: 10,
                    border: "1px solid #bcd6db",
                    fontWeight: 600,
                    cursor: "pointer",
                    fontSize: isMobile ? "13px" : "15px",
                  }}
                />

                <button
                  onClick={fetchDailySales}
                  style={{
                    padding: isMobile ? "8px 16px" : "10px 18px",
                    background: "linear-gradient(120deg, #03b8b3, #04d4cd)",
                    color: "#fff",
                    border: "none",
                    borderRadius: 10,
                    fontWeight: 700,
                    cursor: "pointer",
                    fontSize: isMobile ? "13px" : "15px",
                    width: isMobile ? "100%" : "",
                  }}
                >
                  Show
                </button>
              </div>

              {/* Daily Sales Table */}
              {dailyData.length > 0 ? (
                <div
                  style={{
                    overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: isMobile ? "300px" : "420px",
                    borderRadius: 10,
                    border: "1px solid #e0e0e0",
                    scrollBehavior: "smooth",
                    scrollbarWidth: "thin",
                    scrollbarColor: "#c1c1c1 transparent",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      minWidth: "650px",
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          background: "#03b8b3",
                          color: "#fff",
                          textTransform: "uppercase",
                          position: "sticky",
                          top: 0,
                          zIndex: 5,
                        }}
                      >
                        {[
                          "Date",
                          "User ID",
                          "Name",
                          "Jars",
                          "Capsules",
                          "Total (₹)",
                        ].map((col) => (
                          <th
                            key={col}
                            style={{
                              padding: isMobile ? "6px 4px" : "10px 8px",
                              fontSize: isMobile ? "11px" : "14px",
                            }}
                          >
                            {col}
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {dailyData.map((row, i) => (
                        <tr key={i}>
                          <td
                            style={{ ...tdStyle, fontSize: isMobile ? 11 : 14 }}
                          >
                            {row.date}
                          </td>
                          <td
                            style={{ ...tdStyle, fontSize: isMobile ? 11 : 14 }}
                          >
                            {row.userId}
                          </td>
                          <td
                            style={{ ...tdStyle, fontSize: isMobile ? 11 : 14 }}
                          >
                            {row.userName}
                          </td>
                          <td
                            style={{ ...tdStyle, fontSize: isMobile ? 11 : 14 }}
                          >
                            {row.jarQty}
                          </td>
                          <td
                            style={{ ...tdStyle, fontSize: isMobile ? 11 : 14 }}
                          >
                            {row.capsuleQty}
                          </td>
                          <td
                            style={{ ...tdStyle, fontSize: isMobile ? 11 : 14 }}
                          >
                            ₹{row.totalPrice}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p
                  style={{
                    textAlign: "center",
                    color: "#777",
                    fontSize: isMobile ? 13 : 15,
                  }}
                >
                  No data found for selected date.
                </p>
              )}
            </div>
          )}

        {/* 🧾 Entry Section (same as before) */}
        {!showAll && selectedUser && (
          <>
            {/* Header Section */}
            <div
              style={{
                background: "#fff",
                borderRadius: isMobile ? 8 : 12,
                padding: isMobile ? 10 : 15,
                marginBottom: 20,
                boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: isMobile ? 6 : 10,
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: isMobile ? 6 : 10,
                  alignItems: "center",
                  flexWrap: "wrap",
                  justifyContent: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: 600,
                    color: "#022c32",
                    fontSize: isMobile ? "12px" : "14px",
                  }}
                >
                  Select Month:
                </label>

                <input
                  type="month"
                  value={entryMonth}
                  onChange={(e) => setEntryMonth(e.target.value)}
                  style={{
                    padding: isMobile ? "6px 10px" : "8px 12px",
                    borderRadius: 8,
                    border: "1px solid #bcd6db",
                    outline: "none",
                    cursor: "pointer",
                    fontWeight: 500,
                    fontSize: isMobile ? "12px" : "14px",
                  }}
                />

                <button
                  onClick={() =>
                    setEntryMonth(new Date().toISOString().slice(0, 7))
                  }
                  style={{
                    background: "linear-gradient(120deg, #03b8b3, #04d4cd)",
                    color: "#fff",
                    border: "none",
                    borderRadius: 8,
                    padding: isMobile ? "6px 10px" : "8px 12px",
                    fontWeight: 600,
                    cursor: "pointer",
                    fontSize: isMobile ? "12px" : "14px",
                  }}
                >
                  Current Month
                </button>
              </div>

              {filterDate && (
                <button
                  onClick={() => setFilterDate("")}
                  style={{
                    background: "linear-gradient(120deg, #e53935, #ff5252)",
                    color: "#fff",
                    border: "none",
                    borderRadius: 8,
                    padding: isMobile ? "6px 10px" : "8px 14px",
                    fontWeight: 600,
                    cursor: "pointer",
                    fontSize: isMobile ? "12px" : "14px",
                  }}
                >
                  ✖ Clear
                </button>
              )}

              <button
                onClick={handleDownloadExcel}
                style={{
                  background: "linear-gradient(120deg, #04b870, #02d18f)",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: isMobile ? "6px 12px" : "8px 16px",
                  fontWeight: 600,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 6,
                  width: isMobile ? "100%" : "",
                  fontSize: isMobile ? "12px" : "14px",
                }}
              >
                <DownloadIcon
                  style={{
                    fontSize: isMobile ? "20px" : "26px",
                  }}
                />
                Excel
              </button>
            </div>

            {/* Totals Section */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                flexWrap: "wrap",
                gap: "10px",
                background: "#f1f8f8",
                borderRadius: 10,
                padding: isMobile ? "8px 6px" : "12px 10px",
                marginBottom: 15,
                textAlign: "center",
                fontWeight: 600,
                color: "#022c32",
                fontSize: isMobile ? "12px" : "14px",
              }}
            >
              <div>
                <GiWaterGallon /> Total Capsules: {totalCapsules}
              </div>
              <div>
                <TbBottleFilled /> Total Jars: {totalJars}
              </div>
              <div>
                <FaRupeeSign /> Total Price: ₹{totalPrice.toFixed(2)}
              </div>
            </div>

            {/* Entries Table */}
            <div
              style={{
                background: "#fff",
                borderRadius: isMobile ? 8 : 12,
                boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
                padding: isMobile ? 12 : 20,
              }}
            >
              <h3
                style={{
                  fontWeight: 600,
                  color: "#022c32",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  fontSize: isMobile ? "15px" : "18px",
                }}
              >
                <EditNoteIcon
                  style={{
                    fontSize: isMobile ? "20px" : "26px",
                  }}
                />
                Entries ({filteredEntries.length})
              </h3>

              {filteredEntries.length > 0 ? (
                <div
                  style={{
                    overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: isMobile ? "220px" : "300px",
                    borderRadius: 8,
                    border: "1px solid #e0e0e0",
                    marginTop: 8,
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      textAlign: "left",
                      minWidth: "550px",
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          background: "#03b8b3",
                          color: "#fff",
                          textTransform: "uppercase",
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                        }}
                      >
                        {[
                          "Date",
                          "Cap Qty",
                          "Jar Qty",
                          "Total (₹)",
                          "Actions",
                        ].map((col) => (
                          <th
                            key={col}
                            style={{
                              padding: isMobile ? "6px 4px" : "10px 8px",
                              textAlign: "center",
                              fontSize: isMobile ? "11px" : "14px",
                            }}
                          >
                            {col}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {filteredEntries.map((e) => (
                        <tr key={e.id}>
                          <td
                            style={{ ...tdStyle, fontSize: isMobile ? 11 : 14 }}
                          >
                            {e.date}
                          </td>
                          <td
                            style={{ ...tdStyle, fontSize: isMobile ? 11 : 14 }}
                          >
                            {e.capsuleQty}
                          </td>
                          <td
                            style={{ ...tdStyle, fontSize: isMobile ? 11 : 14 }}
                          >
                            {e.jarQty}
                          </td>
                          <td
                            style={{ ...tdStyle, fontSize: isMobile ? 11 : 14 }}
                          >
                            ₹{e.totalPrice}
                          </td>
                          <td
                            style={{
                              ...tdStyle,
                              display: "flex",
                              gap: isMobile ? "3px" : "5px",
                              justifyContent: "center",
                            }}
                          >
                            <button
                              onClick={() => handleEdit(e)}
                              style={{
                                ...actionBtnStyle,
                                background:
                                  "linear-gradient(120deg, #3498db, #2ecc71)",
                                padding: isMobile ? "4px 6px" : "5px 8px",
                              }}
                            >
                              <EditIcon
                                style={{ fontSize: isMobile ? "14px" : "18px" }}
                              />
                            </button>
                            <button
                              onClick={() => handleDeleteEntry(e.id)}
                              style={{
                                ...actionBtnStyle,
                                background:
                                  "linear-gradient(120deg, #e74c3c, #c0392b)",
                                padding: isMobile ? "4px 6px" : "5px 8px",
                              }}
                            >
                              <DeleteIcon
                                style={{ fontSize: isMobile ? "14px" : "18px" }}
                              />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p
                  style={{
                    color: "#555",
                    textAlign: "center",
                    fontSize: isMobile ? "12px" : "14px",
                  }}
                >
                  No entries found for selected date.
                </p>
              )}
            </div>
          </>
        )}
      </div>

      {showAttendanceModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              width: 350,
              background: "#fff",
              borderRadius: 12,
              padding: 20,
              boxShadow: "0 5px 20px rgba(0,0,0,0.2)",
            }}
          >
            <h3 style={{ marginBottom: 15, fontWeight: 700, color: "#022c32" }}>
              Mark Attendance
            </h3>

            <p>
              <strong>Employee:</strong> {selectedEmpForAttendance?.name}
            </p>

            <label>Date:</label>
            <input
              type="date"
              value={todayDate}
              disabled
              style={{
                width: "100%",
                padding: 8,
                borderRadius: 6,
                border: "1px solid #ccc",
                marginBottom: 15,
              }}
            />

            <label>Status:</label>
            <select
              value={attendanceStatus}
              onChange={(e) => setAttendanceStatus(e.target.value)}
              style={{
                width: "100%",
                padding: 8,
                borderRadius: 6,
                border: "1px solid #ccc",
                marginBottom: 20,
              }}
            >
              <option value="">Select Status</option>
              <option value="present">Present</option>
              <option value="absent">Absent</option>
              <option value="leave">Leave</option>
              <option value="halfday">Half Day</option>
            </select>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <button
                onClick={() => setShowAttendanceModal(false)}
                style={{
                  background: "#ccc",
                  color: "#000",
                  padding: "8px 15px",
                  borderRadius: 6,
                  border: "none",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                Cancel
              </button>

              <button
                onClick={handleSubmitAttendance}
                style={{
                  background: "#03b8b3",
                  color: "#fff",
                  padding: "8px 15px",
                  borderRadius: 6,
                  border: "none",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 🧾 Compact Add/Edit Entry Modal */}
      {showEntryModal && selectedUserDetails && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 100,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "14px",
              borderRadius: 12,
              width: "100%",
              maxWidth: window.innerWidth <= 600 ? 260 : 360,
              boxShadow: "0 8px 22px rgba(0,0,0,0.3)",
            }}
          >
            <h3
              style={{
                textAlign: "center",
                color: "#022c32",
                fontSize: "0.95rem",
                marginBottom: "8px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 6,
                filter: "drop-shadow(1px 1px 1px rgba(0,0,0,0.5))",
                transform: "scale(1.1)",
              }}
            >
              {isEditing ? (
                <>
                  <EditIcon style={{ fontSize: "26px" }} /> Edit Entry
                </>
              ) : (
                <>
                  <AddIcon style={{ fontSize: "26px" }} /> Add Entry
                </>
              )}
            </h3>

            <label style={labelStyle}>Date:</label>
            <input
              type="date"
              value={entryData.date}
              onChange={(e) =>
                setEntryData({ ...entryData, date: e.target.value })
              }
              style={inputStyle}
            />

            <label style={labelStyle}>Capsule Qty:</label>
            <input
              type="number"
              placeholder="0"
              value={entryData.capsuleQty}
              onChange={(e) =>
                setEntryData({ ...entryData, capsuleQty: e.target.value })
              }
              style={inputStyle}
            />

            <label style={labelStyle}>Jar Qty:</label>
            <input
              type="number"
              placeholder="0"
              value={entryData.jarQty}
              onChange={(e) =>
                setEntryData({ ...entryData, jarQty: e.target.value })
              }
              style={inputStyle}
            />

            <div
              style={{
                marginTop: 8,
                padding: 6,
                borderRadius: 8,
                background: "#f1f8f8",
                textAlign: "center",
                fontWeight: 600,
                color: "#022c32",
                fontSize: "0.85rem",
              }}
            >
              💰 ₹{entryData.totalPrice.toFixed(2)}
            </div>

            <div
              style={{
                display: "flex",
                gap: "8px",
                marginTop: "12px",
              }}
            >
              <button
                onClick={isEditing ? handleUpdateEntry : handleSaveEntry}
                style={{
                  ...btnStyle,
                  background: isEditing
                    ? "linear-gradient(120deg, #f39c12, #e67e22)"
                    : "linear-gradient(120deg, #03b8b3, #04d4cd)",
                }}
              >
                {isEditing ? "Update" : "Save"}
              </button>
              <button
                onClick={closeEntryModal}
                style={{
                  ...btnStyle,
                  background: "linear-gradient(120deg, #e53935, #ff5252)",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const isMobile = window.innerWidth <= 600;

const tdStyle = {
  padding: "8px 6px",
  fontSize: isMobile ? 12 : 14,
  borderBottom: "1px solid #e5e5e5",
  textAlign: "center",
};

const labelStyle = {
  fontWeight: 600,
  marginTop: 6,
  marginBottom: 2,
  fontSize: "0.8rem",
  color: "#022c32",
};

const inputStyle = {
  width: "96%",
  paddingTop: "8px",
  paddingBottom: "8px",
  paddingLeft: "8px",
  marginBottom: 6,
  borderRadius: 8,
  border: "1px solid #bcd6db",
  outline: "none",
  fontSize: "0.8rem",
};

const btnStyle = {
  flex: 1,
  padding: "7px 8px",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  fontWeight: 600,
  cursor: "pointer",
  fontSize: "0.8rem",
};

const actionBtnStyle = {
  color: "#fff",
  border: "none",
  borderRadius: 6,
  padding: "5px 8px",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "0.7rem",
};

const thStyle = {
  padding: "10px",
  fontWeight: 700,
  fontSize: 14,
};

const paidBtn = {
  background: "linear-gradient(120deg, #2e7d32, #66bb6a)",
  border: "none",
  color: "#fff",
  padding: "6px 12px",
  borderRadius: 6,
  cursor: "pointer",
  fontWeight: 600,
};

const unpaidBtn = {
  background: "linear-gradient(120deg, #249b48ff, #072d1fff)",
  border: "none",
  color: "#fff",
  padding: "6px 12px",
  borderRadius: 6,
  cursor: "pointer",
  fontWeight: 600,
};

const rejectBtn = {
  padding: "6px 10px",
  borderRadius: 6,
  border: "none",
  background: "#e53935",
  color: "#fff",
  fontWeight: 600,
  cursor: "pointer",
};
